/* Add dot to monthyear heading Jan 21, 2023 */
/* Fix bugs, change date format Dec 2, 2023 */
/* Add time allocation, default end date and make columns resizeable May 10,2025 */
/* Add sorting Aug 23, 2025 */
/* Add timePercent to projectRolesData, use staffingDataId on BarRows Filter, remove start and 
   end dates from ProjectRoles, get data for 12 months  September 20, 2025 */
/* Keep Gantt rows aligned when a long project name wraps Oct 18, 2026 */
/* Use the existing projectHeader record for Project Roles header bars Oct 19, 2026 */
<template>
	<div>
		<b-container  fluid class="project-staffing" style="text-align:left; padding-left:0px; margin-left: 0px; margin-right: 0px;">
		<!-- table -->
			<div class="staffing">
				<strong>Project Staffing</strong>
				<div>
					<!--div class="d-flex"-->
						<div class="d-flex flex-wrap staffing-toolbar">
							<div class="d-flex" style="margin-left:2px;margin-right:20px;">
								<span style="font-size: 87.5%;">View:</span>
								<b-form-select id="viewModeId" v-model="d_viewMode" style="border:none;" :options="d_viewModes" @change="m_changeViewMode"></b-form-select>
							</div>
							<div class="d-flex align-items-left mr-2">
								<span class="mr-1" style="font-size: 87.5%;">From:</span>
								<b-input type="date" style="width:120px;border:none;" @change="m_startDateChange" :value="moment(d_startDate).format('YYYY-MM-DD')"></b-input>
							</div>
							<div class="d-flex align-items-left">
								<span class="mr-1" style="font-size: 87.5%;">To:</span>
								<b-input type="date" style="width:120px;border:none;" @change="m_endDateChange" :value="moment(d_endDate).format('YYYY-MM-DD')"></b-input>
							</div>
							<div class="d-flex">
								<b-button class="btn-refresh" title="Refresh" variant="primary" @click="m_refresh">
									<fa-icon icon="sync" />
								</b-button>
							</div>
							<div class="d-flex align-items-center staffing-toolbar-right" style="margin-left:auto;">
								<div class="staffing-export" title="Export and Reports">
									<b-dropdown right variant="outline-secondary" class="btn-menu staffing-export-dropdown">
										<span @click="m_closeChildWindow" style="background-color:white;" class="topright-close">&times;</span>
										<template v-slot:button-content>
											<fa-icon icon="file-export" />
										</template>
										<kt-reports
											:key="'staffing-reports-' + d_viewMode + '-' + d_componentKey"
											p_tableName="Staffing"
											:p_cols="c_reportCols"
											:p_tableData="c_reportTableData"
											:p_sort="c_reportSort"
											:p_filters="d_filters"
											:p_ganttBars="c_filterBarRows"
											:p_chartStartDate="d_chartStartDate"
											:p_chartEndDate="d_chartEndDate"
											:p_viewMode="d_viewMode"
										/>
									</b-dropdown>
								</div>
								<div class="d-flex staffing-filter">
									<filter-component v-if="d_cols.length > 0"  :key="d_componentKey" :p_filterData="c_filterData"  :p_columns="d_cols" p_tableName="Staffing" p_tblId="Staffing"
									:p_filters="d_filters" @close="m_closeChildWindow" @filters="m_filterTableData" @clearFilters="m_clearFilters">
									</filter-component>
								</div>
							</div>
						</div>
				</div>
				<div id="mainContainer" class="staffing-main">
					<div id="staffingScroll" class="staffing-body-scroll">
					<b-row no-gutters class="staffing-split-row align-items-start">
						<b-col cols="auto" id="tableColumn" class="resizable table-column">
						<div class="table-year-header" aria-hidden="true"></div>
						<div v-show="d_viewMode=='Team Members'">
							<b-table id="TeamMembers" 	class="font-weight-bold staffing-table" style="font-size: 11px; margin-left: 0px; margin-right: 0px;margin-bottom:0.5px;"
							striped borderless hover :items="c_filterStaffingData" :fields="d_teamMembersFields" tbody-tr-class="rowStyle" >
								<template #head(teamMemberName)>
									<span class="sortableColumn" @click="m_sortClick($event,'teamMemberName')">Name</span>
									<fa-icon v-if="d_currentSort[d_viewMode]==1 && d_sortColumn[d_viewMode]=='teamMemberName'" icon="arrow-up"  style="color:orange;"></fa-icon>
									<fa-icon v-if="d_currentSort[d_viewMode]==-1 && d_sortColumn[d_viewMode]=='teamMemberName'" icon="arrow-down" style="color:#52c1fa;"></fa-icon>
								</template>
								<template #cell(teamMemberName)="data">
									<div v-if="data.index==0||m_teamMemberChange(data.index)" class="staffing-name-cell">
										<b-icon v-if="m_visibleTeamMember(data.item)" icon="arrow-down-circle-fill" variant="primary" @click="m_collapseTeamMembers(data.item)"></b-icon>
										<b-icon v-if="m_notVisibleTeamMember(data.item)" icon="arrow-right-circle-fill" variant="success" @click="m_expandTeamMembers(data.item)"></b-icon>
										<span
											v-if="data.item.teamMemberId || data.item.teamMemberName"
											class="staffing-photo-bubble"
											:title="data.item.teamMemberName"
											@click="m_viewModal(data.item.teamMemberNo)"
										>
											<img
												v-if="data.item.image && !data.item.photoFailed"
												:src="data.item.image"
												alt=""
												@error="m_photoError(data.item)"
											/>
											<span v-else class="staffing-photo-initials">{{ m_teamMemberInitials(data.item.teamMemberName) }}</span>
										</span>
										<a :href="data.item.teamMemberLink" target="_blank"> {{data.item.teamMemberName}}</a>
									</div>
								</template>
								<template #cell(roleName)="data">
									<div class="staffing-wrap-text">
										<span class="staffing-title" :style="{ color: m_titleColor(data.item.roleName) }">{{data.item.roleName}}</span>
									</div>
								</template>	
								<template #cell(startDate)="data">
									<div>
										<span>{{data.item.startDate}}</span>
									</div>
								</template>	
								<template #cell(endDate)="data">
									<div>
										<span>{{data.item.endDate}}</span>
									</div>
								</template>	
								<template #cell(timePercent)="data">
									<div>
										<span>{{data.item.timePercent}}<span v-if="data.item.timePercent">%</span></span>
									</div>
								</template>									
							</b-table>
						</div>
						<div v-show="d_viewMode=='Project Roles'">
							<b-table id="ProjectRoles" class="font-weight-bold staffing-table" style="font-size: 11px; margin-left: 0px; margin-right: 0px;margin-bottom:0.5px;"
							striped borderless hover :items="c_filterStaffingData" 	:fields="d_projectRolesFields" 	tbody-tr-class="rowStyle" >
								<template #head(recordName)>
									<span class="sortableColumn" @click="m_sortClick($event,'recordName')">Project</span>
									<fa-icon v-if="d_currentSort[d_viewMode]==1 && d_sortColumn[d_viewMode]=='recordName'" icon="arrow-up"  style="color:orange;"></fa-icon>
									<fa-icon v-if="d_currentSort[d_viewMode]==-1 && d_sortColumn[d_viewMode]=='recordName'" icon="arrow-down" style="color:#52c1fa;"></fa-icon>
								</template>
								<template #cell(recordName)="data">
									<div v-if="data.item.isProjectBar || data.index==0 || m_projectNameChange(data.index)" class="staffing-wrap-text">
										<b-icon v-if="m_visibleProjectRole(data.item)" icon="arrow-down-circle-fill" variant="primary" @click="m_collapseProjectRoles(data.item)"></b-icon>
										<b-icon v-if="m_notVisibleProjectRole(data.item)" icon="arrow-right-circle-fill" variant="success" @click="m_expandProjectRoles(data.item)"></b-icon>									
										<a :href="data.item.link" target="_blank"> {{data.item.projectName}}</a>
									</div>
								</template>
								<template #cell(roleName)="data">
									<div v-if="!data.item.isProjectBar" class="staffing-wrap-text">
										<span class="staffing-title" :style="{ color: m_titleColor(data.item.roleName) }">{{data.item.roleName}}</span>
									</div>
								</template>	
								<template #cell(teamMemberName)="data">
									<div v-if="!data.item.isProjectBar" class="staffing-name-cell">
										<span
											class="staffing-photo-bubble"
											:class="{ 'staffing-photo-bubble--unfilled': !data.item.teamMemberId }"
											:title="data.item.teamMemberId ? data.item.teamMemberName : 'Needs To Be Filled'"
											@click="data.item.teamMemberId && m_viewModal(data.item.teamMemberNo)"
										>
											<img
												v-if="data.item.teamMemberId && data.item.image && !data.item.photoFailed"
												:src="data.item.image"
												alt=""
												@error="m_photoError(data.item)"
											/>
											<span v-else-if="data.item.teamMemberId" class="staffing-photo-initials">{{ m_teamMemberInitials(data.item.teamMemberName) }}</span>
											<fa-icon v-else icon="user" class="staffing-photo-silhouette" />
										</span>
										<span v-if="!data.item.teamMemberId&&data.item.roleId" class="staffing-unfilled-name">Needs To Be Filled</span>
										<a v-else :href="data.item.teamMemberLink" target="_blank"> {{data.item.teamMemberName}}</a>
									</div>
								</template>
								<template #cell(timePercent)="data">
									<div v-if="!data.item.isProjectBar" style="text-wrap:nowrap;">
										<span v-if="data.item.timePercent!=null && data.item.timePercent!==''">{{data.item.timePercent}}%</span>
									</div>
								</template>										
							</b-table>
						</div>
						<div v-show="d_viewMode=='Project Staff General Conditions'">
							<b-table id="GeneralConditions" class="font-weight-bold staffing-table" style="font-size: 11px; margin-left: 0px; margin-right: 0px;margin-bottom:0.5px;"
							striped borderless hover :items="c_filterStaffingData" 	:fields="d_generalConditionsFields" 	:tbody-tr-class="m_gcRowClass" >
								<template #head(recordName)>
									<span class="sortableColumn" @click="m_sortClick($event,'recordName')">Project</span>
									<fa-icon v-if="d_currentSort[d_viewMode]==1 && d_sortColumn[d_viewMode]=='recordName'" icon="arrow-up"  style="color:orange;"></fa-icon>
									<fa-icon v-if="d_currentSort[d_viewMode]==-1 && d_sortColumn[d_viewMode]=='recordName'" icon="arrow-down" style="color:#52c1fa;"></fa-icon>
								</template>
								<template #cell(recordName)="data">
									<div v-if="data.item.isProjectTotal || data.item.isGrandTotal" class="staffing-gc-total-label">
										{{ data.item.isGrandTotal ? 'Grand Total' : 'Total' }}
									</div>
									<div v-else-if="data.item.isProjectBar || data.index==0 || m_projectNameChange(data.index)" class="staffing-wrap-text">
										<b-icon v-if="m_visibleProjectRole(data.item)" icon="arrow-down-circle-fill" variant="primary" @click="m_collapseProjectRoles(data.item)"></b-icon>
										<b-icon v-if="m_notVisibleProjectRole(data.item)" icon="arrow-right-circle-fill" variant="success" @click="m_expandProjectRoles(data.item)"></b-icon>									
										<a :href="data.item.link" target="_blank"> {{data.item.projectName}}</a>
									</div>
								</template>
								<template #cell(roleName)="data">
									<div v-if="!data.item.isProjectBar && !data.item.isProjectTotal && !data.item.isGrandTotal" class="staffing-wrap-text">
										<span class="staffing-title" :style="{ color: m_titleColor(data.item.roleName) }">{{data.item.roleName}}</span>
									</div>
								</template>	
								<template #cell(teamMemberName)="data">
									<div v-if="!data.item.isProjectBar && !data.item.isProjectTotal && !data.item.isGrandTotal" class="staffing-name-cell">
										<span
											class="staffing-photo-bubble"
											:class="{ 'staffing-photo-bubble--unfilled': !data.item.teamMemberId }"
											:title="data.item.teamMemberId ? data.item.teamMemberName : 'Needs To Be Filled'"
											@click="data.item.teamMemberId && m_viewModal(data.item.teamMemberNo)"
										>
											<img
												v-if="data.item.teamMemberId && data.item.image && !data.item.photoFailed"
												:src="data.item.image"
												alt=""
												@error="m_photoError(data.item)"
											/>
											<span v-else-if="data.item.teamMemberId" class="staffing-photo-initials">{{ m_teamMemberInitials(data.item.teamMemberName) }}</span>
											<fa-icon v-else icon="user" class="staffing-photo-silhouette" />
										</span>
										<span v-if="!data.item.teamMemberId&&data.item.roleId" class="staffing-unfilled-name">Needs To Be Filled</span>
										<a v-else :href="data.item.teamMemberLink" target="_blank"> {{data.item.teamMemberName}}</a>
									</div>
								</template>
								<template #cell(staffCost)="data">
									<div v-if="!data.item.isProjectBar" style="text-wrap:nowrap;" :class="{ 'staffing-gc-total-cost': data.item.isProjectTotal || data.item.isGrandTotal }">
										<span v-if="data.item.staffCost!=null && data.item.staffCost!==''">{{ m_costFormat(data.item.staffCost) }}</span>
									</div>
								</template>										
							</b-table>
						</div>
						<div v-show="d_viewMode=='Availability'">
							<b-table id="Availability" class="font-weight-bold staffing-table" style="font-size: 11px; margin-left: 0px; margin-right: 0px;margin-bottom:0.5px;"
							striped borderless hover :items="c_filterStaffingData" :fields="d_availabilityFields" tbody-tr-class="rowStyle" >
								<template #head(teamMemberName)>
									<span class="sortableColumn" @click="m_sortClick($event,'teamMemberName')">Name</span>
									<fa-icon v-if="d_currentSort[d_viewMode]==1 && d_sortColumn[d_viewMode]=='teamMemberName'" icon="arrow-up"  style="color:orange;"></fa-icon>
									<fa-icon v-if="d_currentSort[d_viewMode]==-1 && d_sortColumn[d_viewMode]=='teamMemberName'" icon="arrow-down" style="color:#52c1fa;"></fa-icon>
								</template>
								<template #head(position)>
									<span class="sortableColumn" @click="m_sortClick($event,'position')">Position</span>
									<fa-icon v-if="d_currentSort[d_viewMode]==1 && d_sortColumn[d_viewMode]=='position'" icon="arrow-up"  style="color:orange;"></fa-icon>
									<fa-icon v-if="d_currentSort[d_viewMode]==-1 && d_sortColumn[d_viewMode]=='position'" icon="arrow-down" style="color:#52c1fa;"></fa-icon>
								</template>
								<template #head(availablePercent)>
									<span class="sortableColumn" @click="m_sortClick($event,'availablePercent')">Avail %</span>
									<fa-icon v-if="d_currentSort[d_viewMode]==1 && d_sortColumn[d_viewMode]=='availablePercent'" icon="arrow-up"  style="color:orange;"></fa-icon>
									<fa-icon v-if="d_currentSort[d_viewMode]==-1 && d_sortColumn[d_viewMode]=='availablePercent'" icon="arrow-down" style="color:#52c1fa;"></fa-icon>
								</template>
								<template #cell(teamMemberName)="data">
									<div class="staffing-name-cell">
										<span
											v-if="data.item.teamMemberId || data.item.teamMemberName"
											class="staffing-photo-bubble"
											:title="data.item.teamMemberName"
											@click="m_viewModal(data.item.teamMemberNo)"
										>
											<img
												v-if="data.item.image && !data.item.photoFailed"
												:src="data.item.image"
												alt=""
												@error="m_photoError(data.item)"
											/>
											<span v-else class="staffing-photo-initials">{{ m_teamMemberInitials(data.item.teamMemberName) }}</span>
										</span>
										<a :href="data.item.teamMemberLink" target="_blank"> {{data.item.teamMemberName}}</a>
									</div>
								</template>
								<template #cell(position)="data">
									<div class="staffing-wrap-text">
										<span>{{data.item.position}}</span>
									</div>
								</template>	
								<template #cell(availablePercent)="data">
									<div  style="text-wrap:nowrap;">
										<span>{{data.item.availablePercent}}%</span>
									</div>
								</template>	
							</b-table>
						</div>
						<div class="resizer2"></div>
						</b-col>
						<b-col id="chartColumn" class="resizable chart-column flex-grow-1">
							<div draggable="false" id="chartContainer" class="chart-container">
								<div class="d-flex align-items-center font-weight-bold chart-year-header">
									<div
										v-for="span in c_yearSpans"
										:key="'year-' + span.year + '-' + span.months"
										class="chart-year-label"
										:style="{ flex: (span.days || span.months) + ' 1 0px' }"
									>
										{{ span.year }}
									</div>
								</div>
								<div
								class="
								d-flex
								align-items-center
								font-weight-bold
								chart-month-header">
									<div
										v-for="month in m_getMonthDiff()"
										:key="month"
										class="chart-month-label"
										:class="{ 'chart-month-label--divided': c_showMonthDividers }"
										:style="{ flex: m_monthDaySpan(month - 1) + ' 1 0px' }"
									>
										{{ m_getMonthLabel(month-1) }}
									</div>
								</div>
								<div class="chart-gantt-wrap">
									<div
										v-if="c_showMonthDividers"
										class="chart-month-grid"
										aria-hidden="true"
									>
										<div
											v-for="month in m_getMonthDiff()"
											:key="'grid-' + month"
											class="chart-month-grid-col"
											:style="{ flex: m_monthDaySpan(month - 1) + ' 1 0px' }"
										></div>
									</div>
									<div
										v-if="d_viewMode=='Project Staff General Conditions'"
										class="chart-month-cost-overlay"
										aria-hidden="true"
									>
										<div
											v-for="(row, idx) in c_gcOverlayRows"
											:key="'gc-cost-' + idx"
											class="chart-month-cost-row"
											:class="{ 'chart-month-cost-row--total': row.isTotal, 'chart-month-cost-row--grand': row.isGrandTotal }"
										>
											<div
												v-for="month in m_getMonthDiff()"
												:key="'gc-cost-' + idx + '-' + month"
												class="chart-month-cost-cell"
												:style="{ flex: m_monthDaySpan(month - 1) + ' 1 0px' }"
											>
												<span v-if="!row.isHeader && m_gcMonthCost(row, month-1)">{{ m_costFormat(m_gcMonthCost(row, month-1)) }}</span>
											</div>
										</div>
									</div>
								<g-gantt-chart
								:hideTimeaxis="true"
								:chart-start="d_chartStartDate"
								:chart-end="d_chartEndDate"
								row-label-width="0%"
								:row-height="d_rowHeight"
								precision="day"
								@drag-bar="m_dragBar"
								@dragstart-bar="m_dragStart">
									<g-gantt-row
										v-for="row in c_filterBarRows"
											:key="row.id"
											:bars="row.bars"
											bar-start="startDate"
											bar-end="endDate"
											precision="day"
											highlight-on-hover="true"
											bar-label="label"
									>
										<template #bar-label="{ bar }">
											<div
											class="gantt-bar-label"
											:class="{ 'gantt-bar-label--alloc': c_isProjectRolesLike && m_barAllocLabel(bar) }"
											:title="m_barTitle(bar)"
											>
												<span
													v-if="c_isProjectRolesLike && m_barAllocLabel(bar)"
													class="gantt-bar-alloc"
													:style="{'color': bar.ganttBarConfig.color || '#fff'}"
												>{{ m_barAllocLabel(bar) }}</span>
												<template v-else>
													<a v-if="bar.ganttBarConfig.link" :href="bar.ganttBarConfig.link" class="gantt-bar-text" :class="{ 'gantt-bar-text--bold': d_viewMode=='Team Members' }" :style="{'color': m_barLabelColor(bar)}" target="_blank"> {{ bar.ganttBarConfig.label}}</a>
													<span v-else class="gantt-bar-text" :class="{ 'gantt-bar-text--bold': d_viewMode=='Team Members' }" :style="{'color': m_barLabelColor(bar)}">{{ bar.ganttBarConfig.label}}</span>
												</template>
											</div>
										</template>
									</g-gantt-row>
								</g-gantt-chart>
								</div>
							</div>
						</b-col>
					</b-row>
					</div>
						<kt-spinner v-if="d_loading" p_txt="Staffing Data"></kt-spinner>
					<div
						v-if="d_viewMode=='Team Members'"
						class="staffing-color-keys"
					>
						<div class="staffing-color-key" aria-label="Team Member Gantt color key">
							<span class="staffing-color-key-title">Team Member Gantt Color Key</span>
							<span class="staffing-color-key-item">
								<span class="staffing-color-swatch staffing-color-swatch--precon" aria-hidden="true">&nbsp;</span>
								<span class="staffing-color-label staffing-color-label--precon">Precon</span>
							</span>
							<span class="staffing-color-key-item">
								<span class="staffing-color-swatch staffing-color-swatch--construction" aria-hidden="true">&nbsp;</span>
								<span class="staffing-color-label staffing-color-label--construction">Construction Phase</span>
							</span>
							<span class="staffing-color-key-item">
								<span
									class="staffing-color-swatch"
									aria-hidden="true"
									:style="{ backgroundColor: d_ganttColors.opportunity }"
								>&nbsp;</span>
								<span class="staffing-color-label" :style="{ color: d_ganttColors.opportunity }">Role on Potential Project</span>
							</span>
						</div>
					</div>
					<div
						v-if="d_viewMode=='Availability'"
						class="staffing-color-keys"
					>
						<div class="staffing-color-key" aria-label="Team Member Gantt color key">
							<span class="staffing-color-key-title">Team Member Gantt Color Key</span>
							<span class="staffing-color-key-item">
								<span class="staffing-color-swatch staffing-color-swatch--construction" aria-hidden="true">&nbsp;</span>
								<span class="staffing-color-label staffing-color-label--construction">On Project</span>
							</span>
							<span class="staffing-color-key-item">
								<span
									class="staffing-color-swatch"
									aria-hidden="true"
									:style="{ backgroundColor: d_ganttColors.available }"
								>&nbsp;</span>
								<span class="staffing-color-label" :style="{ color: d_ganttColors.available }">Available</span>
							</span>
						</div>
					</div>
					<div
						v-if="d_viewMode=='Project Roles' || d_viewMode=='Project Staff General Conditions'"
						class="staffing-color-keys"
					>
						<div class="staffing-color-key" aria-label="Team Member Gantt color key">
							<span class="staffing-color-key-title">Team Member Gantt Color Key</span>
							<span class="staffing-color-key-item">
								<span class="staffing-color-swatch staffing-color-swatch--precon" aria-hidden="true">&nbsp;</span>
								<span class="staffing-color-label staffing-color-label--precon">Precon</span>
							</span>
							<span class="staffing-color-key-item">
								<span class="staffing-color-swatch staffing-color-swatch--construction" aria-hidden="true">&nbsp;</span>
								<span class="staffing-color-label staffing-color-label--construction">Construction Phase</span>
							</span>
							<span class="staffing-color-key-item">
								<span class="staffing-color-swatch staffing-color-swatch--unfilled" aria-hidden="true">&nbsp;</span>
								<span class="staffing-color-label staffing-color-label--unfilled">Role Needs to be Filled</span>
							</span>
						</div>
						<div class="staffing-color-key" aria-label="Project Gantt Bar color key">
							<span class="staffing-color-key-title">Project Gantt Bar Color Key</span>
							<span class="staffing-color-key-item">
								<span class="staffing-color-swatch staffing-color-swatch--precon" aria-hidden="true">&nbsp;</span>
								<span class="staffing-color-label staffing-color-label--precon">Precon</span>
							</span>
							<span class="staffing-color-key-item">
								<span class="staffing-color-swatch staffing-color-swatch--project-construction" aria-hidden="true">&nbsp;</span>
								<span class="staffing-color-label staffing-color-label--project-construction">Construction Phase</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		<!--/div-->
		</b-container>
	</div>
</template>
<script>
import {enableResizableColumn,enableResizableTable,fn_hrefVwRec,kbdpRecord,fn_profilePicURL} from "@/utils/util.js";
import {fn_getAllStaffingData} from "@/utils/api.js";
import { GGanttChart, GGanttRow } from "vue-ganttastic";
import FilterComponent from '@/components/Ctrl/KT-FilterComponent.vue';
import KTReports from '@/components/Ctrl/KT-Reports.vue';
import moment from "moment";
// Scale Gantt bars to the chart width. Kept in this file so QA and Production
// get the fix by copying KT-Staffing.vue; node_modules/vue-ganttastic is unchanged.
fn_patchGanttBarScale(GGanttRow);
// TEMPORARY: OFFLINE SAMPLE DATA — remove with sampleTableData.js / OFFLINE_SAMPLE_DATA.md
//import { USE_SAMPLE_DATA, fn_getSampleAllStaffingData, fn_sampleProfilePicURL } from "@/utils/sampleTableData.js";
//import {firstBy} from "thenby";

/** Shared Gantt bar colors — keep color keys in sync with bar rendering */
const GANTT_COLORS = {
	opportunity: "#9dc254", // Role on Potential Project (Team Members)
	project: "#4076ba",
	available: "#68BB59",
	precon: "#9c27b0",
	projectHeader: "#3399ff",
	unfilled: "#dc3545",
};

export default {
  name: "ProjectStaffing",
  components: {
    GGanttChart,
    GGanttRow,
	"filter-component":FilterComponent,
	"kt-reports":KTReports,
  },
  data() {
    return {
	d_ganttColors: GANTT_COLORS,
	d_containerWidth:2000,
	d_recordType:null,
	d_dbStaffingData:[],
	d_loading:null,
	d_staffingData:[],
	d_startDate:null,
	d_endDate:null,
	d_chartStartDate:null,
	d_chartEndDate:null,
	d_ganttBarConfig:{label: null,color: "#ffffff",borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px",background:null,fontSize: "8px",handles: false,drag: false},
	d_bar:{
                startDate: null,
                endDate: null,
				recordType:null,
				recordNo:null,
                ganttBarConfig: null
              },
	d_barRows:[],    
	filterBy: [],
	moment,
	dateFilter: "date",
	d_chartRangeValue:10,
	d_today:null,
	d_linkFn: (type, recNo) => {
				return fn_hrefVwRec(type, recNo);
				},
	d_viewMode:'Team Members',
	d_viewModes:['Team Members','Project Roles','Project Staff General Conditions','Availability'],
	d_teamMemberName:null,
	d_teamMemberId:null,
	d_teamMembers:[],
	d_selectedOpportunity:null,
	d_selectedProject:null,
	d_selectedRecord:null,
	d_selectedRole:null,
	d_projectStaffingData:[],
	d_projectBarRows:[],
	d_componentKey:1,
	d_filters:null,
	d_rowHeight:48,
	d_teamMembersFields:[{key:"teamMemberName",label:"Name",thStyle:{width:"120px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
						{key:"roleName",label:"Title",thStyle:{width:"110px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
						{key:"startDate",label:"Start",thStyle:{width:"85px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell"},
						{key:"endDate",label:"End",thStyle:{width:"85px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell"},
						{key:"timePercent",label:"Alloc %",thStyle:{width:"60px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell"},
						],
	d_projectRolesFields:[{key:"recordName",label:"Project",thStyle:{width:"120px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
						{key:"roleName",label:"Title",thStyle:{width:"110px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
						{key:"teamMemberName",label:"Name",thStyle:{width:"120px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
						{key:"timePercent",label:"Alloc %",thStyle:{width:"60px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell"},
						],
	d_generalConditionsFields:[{key:"recordName",label:"Project",thStyle:{width:"120px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
						{key:"roleName",label:"Title",thStyle:{width:"110px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
						{key:"teamMemberName",label:"Name",thStyle:{width:"120px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
						{key:"staffCost",label:"Staff $",thStyle:{width:"80px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell"},
						],
	d_availabilityFields:[	{key:"teamMemberName",label:"Name",thStyle:{width:"140px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
							{key:"position",label:"Position",thStyle:{width:"140px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell staffing-cell-wrap"},
							{key:"availablePercent",label:"Avail %",thStyle:{width:"60px",borderRight:"0.2px solid #dee2e6",borderBottom:"solid"},tdClass:"staffing-cell"},
						],
	d_cols:[{field:"recordType",title:"Type",visible:true,datatype:"text"},
			{field:"project",title:"Project",visible:true,datatype:"text"},
			{field:"opportunity",title:"Opportunity",visible:true,datatype:"text"},
			{field:"roleName",title:"Title",visible:true,datatype:"text"},
			{field:"teamMemberName",title:"Name",visible:true,datatype:"text"},
			{field:"startDate",title:"Start Date",visible:true,datatype:"date"},
			{field:"endDate",title:"End Date",visible:true,datatype:"date"},
			{field:"position",title:"Position",visible:true,datatype:"text"},
			{field:"timePercent",title:"Time Allocation",visible:true,datatype:"num"},
			{field:"availablePercent",title:"Percent Available",visible:true,datatype:"num"},
			],
	d_teamMembers_cols:[{field:"recordType",title:"Type",visible:true,datatype:"text"},
			{field:"project",title:"Project",visible:true,datatype:"text"},
			{field:"opportunity",title:"Opportunity",visible:true,datatype:"text"},
			{field:"roleName",title:"Title",visible:true,datatype:"text"},
			{field:"teamMemberName",title:"Name",visible:true,datatype:"text"},
			{field:"startDate",title:"Start Date",visible:true,datatype:"date"},
			{field:"endDate",title:"End Date",visible:true,datatype:"date"},
			{field:"timePercent",title:"Time Allocation",visible:true,datatype:"num"},
			],
	d_projectRoles_cols:[{field:"recordType",title:"Type",visible:true,datatype:"text"},
			{field:"recordName",title:"Project",visible:true,datatype:"text"},
			{field:"opportunity",title:"Opportunity",visible:true,datatype:"text"},
			{field:"roleName",title:"Title",visible:true,datatype:"text"},
			{field:"teamMemberName",title:"Name",visible:true,datatype:"text"},
			{field:"timePercent",title:"Time Allocation",visible:true,datatype:"num"},
			],
	d_generalConditions_cols:[{field:"recordType",title:"Type",visible:true,datatype:"text"},
			{field:"recordName",title:"Project",visible:true,datatype:"text"},
			{field:"opportunity",title:"Opportunity",visible:true,datatype:"text"},
			{field:"roleName",title:"Title",visible:true,datatype:"text"},
			{field:"teamMemberName",title:"Name",visible:true,datatype:"text"},
			{field:"staffCost",title:"Staff $",visible:true,datatype:"num"},
			],
	d_availability_cols:[{field:"teamMemberName",title:"Name",visible:true,datatype:"text"},
					{field:"position",title:"Position",visible:true,datatype:"text"},
					{field:"availablePercent",title:"Availability",visible:true,datatype:"num"},
					], 
	d_collapsedTeamMembers:[],
	d_collapsedProjectRoles:[],
	d_currentSort:{"Team Members":1,"Project Roles":1,"Project Staff General Conditions":1,Availability:1},
	d_sortColumn:{"Team Members":"teamMemberName","Project Roles":"recordName","Project Staff General Conditions":"recordName",Availability:"teamMemberName"},
	d_teamMembersData:[],
	d_teamMembersBars:[],
	d_projectRolesData:[],
	d_projectRolesBars:[],
	d_generalConditionsData:[],
	d_generalConditionsBars:[],
	d_availabilityData:[],
	d_availabilityBars:[],
    };
  },
  created(){
			var today=new Date();
			this.d_today=today.toISOString().slice(0,10)+" 00:00:00";
			this.m_getStaffingData();
	
  },
  mounted() {

	
	enableResizableColumn("resizer2");
	["TeamMembers","ProjectRoles","GeneralConditions","Availability"].forEach(t=>{enableResizableTable(t);});

	this.$nextTick(() => {
		const chartCol = document.getElementById("chartColumn");
		if (chartCol && typeof ResizeObserver !== "undefined") {
			this._chartResizeObserver = new ResizeObserver(() => {
				window.dispatchEvent(new Event("resize"));
			});
			this._chartResizeObserver.observe(chartCol);
		}
		const tableCol = document.getElementById("tableColumn");
		if (tableCol && typeof ResizeObserver !== "undefined") {
			this._tableResizeObserver = new ResizeObserver(() => {
				this.m_scheduleRowHeightSync();
			});
			this._tableResizeObserver.observe(tableCol);
		}
		this.m_scheduleRowHeightSync();
	});
  },
  updated() {
	this.m_scheduleRowHeightSync();
  },
  beforeDestroy() {
	if (this._rowSyncFrame) {
		cancelAnimationFrame(this._rowSyncFrame);
		this._rowSyncFrame = 0;
	}
	if (this._chartResizeObserver) {
		this._chartResizeObserver.disconnect();
		this._chartResizeObserver = null;
	}
	if (this._tableResizeObserver) {
		this._tableResizeObserver.disconnect();
		this._tableResizeObserver = null;
	}
  },
  computed: {
			c_rowClass(){return 'rowStyle';},
			c_currentDayPos(){return fn_getDaysDiff(this.d_chartStartDate,this.d_today)*5.53;},
			c_isProjectRolesLike(){
				return this.d_viewMode==='Project Roles' || this.d_viewMode==='Project Staff General Conditions';
			},
			c_showMonthDividers(){
				return this.d_viewMode==='Project Staff General Conditions';
			},
			c_gcOverlayRows(){
				if(this.d_viewMode!=='Project Staff General Conditions') return [];
				var dataRows=this.d_generalConditionsData||[];
				return (this.c_filterBarRows||[]).map(barRow=>{
					if(barRow.isProjectTotal || barRow.isGrandTotal || String(barRow.staffingDataId||'').indexOf('project-total-')===0 || barRow.staffingDataId==='grand-total'){
						var totalMatch=dataRows.find(d=>d.staffingDataId===barRow.staffingDataId);
						return {
							isHeader:false,
							isTotal:true,
							isGrandTotal:!!(barRow.isGrandTotal || (totalMatch && totalMatch.isGrandTotal)),
							monthlyCosts:(totalMatch && totalMatch.monthlyCosts) || {},
						};
					}
					var isHeader=barRow.roleId===0 || !barRow.roleRowKey || String(barRow.staffingDataId||'').indexOf('project-bar-')===0;
					if(isHeader) return { isHeader:true, isTotal:false, isGrandTotal:false, monthlyCosts:{} };
					var match=dataRows.find(d=>d.roleRowKey && barRow.roleRowKey && d.roleRowKey===barRow.roleRowKey);
					return { isHeader:false, isTotal:false, isGrandTotal:false, monthlyCosts:(match && match.monthlyCosts) || {} };
				});
			},
			c_yearSpans() {
				if (!this.d_chartStartDate || !this.d_chartEndDate) return [];
				const monthCount = this.m_getMonthDiff();
				const spans = [];
				for (let i = 0; i < monthCount; i++) {
					const year = moment(this.d_chartStartDate).startOf("month").add(i, "months").year();
					const days = this.m_monthDaySpan(i);
					const last = spans[spans.length - 1];
					if (last && last.year === year) {
						last.months += 1;
						last.days += days;
					} else {
						spans.push({ year, months: 1, days: days });
					}
				}
				return spans;
			},
			c_filterData() {
			var filter_data = {};
				this.d_cols.forEach(col => {
				filter_data[col.field] = {
					name: col.title,
					data: [],
					hasRefData: false,
					range: false,
					min:null,
					max:null,
					date: col.field.includes('Date')||col.field.includes('UTC'),
					selectedCount:0
				};

				let refID = col._refId !== undefined ? col._refId : null;
				let refName = col._refName !== undefined ? col._refName : null;

				if (col && col.datatype === 'num') {
					filter_data[col.field].range = true;
				}

				if ('_refData' in col && col._refData && col._refData.length > 0) {
					filter_data[col.field].hasRefData = true;
					
						
					col._refData.forEach(obj => {
						const hasID = 'id' in obj;

						if (refID || refName && !hasID) {
							refID = refID !== null && refID !== undefined ? refID : refName.split('Name')[0]+'Id';
							refName = refName !== null && refName !== undefined ? refName : refID.split('Id')[0]+'Name';

							filter_data[col.field].data.push({
								id: obj[refID],
								name: obj[refName]
							});
						}
						else {
							filter_data[col.field].data.push({
								id: obj.id,
								name: obj.name
							});
						}
					});
				}
			});


			var min;
			var max;
			var values;
			var valueIndex;
			this.d_staffingData.forEach(rowObject => {
				for(const key in rowObject) {
					if (filter_data[key]) {
					
						if (!filter_data[key].hasRefData) {
							valueIndex=filter_data[key].data.findIndex(v=>v.value==rowObject[key]);
							if (rowObject[key]&&valueIndex==-1) filter_data[key].data.push({value:rowObject[key]});
							//if(valueIndex !=-1) filter_data[key].data.push({value:rowObject[key]});
						} 
						
						if (filter_data[key].range) {
							values=filter_data[key].data.map(d=>{return d.value;});
							min = Math.min(...values);
							max = Math.max(...values);
							
							if (min && max) {
								filter_data[key].actualMin=min;
								filter_data[key].actualMax=max;
								filter_data[key].min=min;
								filter_data[key].max=max;
							}
						}
						
						if (filter_data[key].date) {
								values=filter_data[key].data
									.map(d=>fn_validDateMs(d.value))
									.filter(t=>Number.isFinite(t));
								if (values.length) {
									min = Math.min(...values);
									max = Math.max(...values);
									filter_data[key].actualMin=fn_isoDateOnly(min);
									filter_data[key].actualMax=fn_isoDateOnly(max);
									filter_data[key].min=fn_isoDateOnly(min);
									filter_data[key].max=fn_isoDateOnly(max);
								}
						}
						
						

					}


				}
				
			});
			
			
			this.d_cols.forEach(col => {
				if(filter_data[col.field].data.length==0) delete filter_data[col.field];
				});	
			

			return filter_data
		},
		c_filterStaffingData() {
		
			console.log('In c_filterStaffingData');
			console.log(this.d_filters);

			return this.d_staffingData.filter(data => {
				for (const key in this.d_filters) {
				
		
				
					if (this.d_filters[key] && this.d_filters[key].range &&
						!(this.d_filters[key].min <= data[key] && data[key] <= this.d_filters[key].max)
					) {
						return false;
					}	

					if (this.d_filters[key] && this.d_filters[key].date &&
						!((new Date(data[key])) >= (new Date(this.d_filters[key].min)) &&
						(new Date(data[key])) <= (new Date(this.d_filters[key].max)))
					) {
						return false;
					}
					
					if (this.d_filters[key] && this.d_filters[key].length && 
						!~this.d_filters[key].indexOf(data[key])
					) {
						return false;
					}


				}
				
					var row;
					if(this.d_viewMode=='Team Members'){
						row=this.d_collapsedTeamMembers.filter(t=>t.teamMemberId==data.teamMemberId)[0];
						if(row&&row.staffingDataId !=data.staffingDataId) return false;
						}
						
					if(this.d_viewMode=='Project Roles' || this.d_viewMode=='Project Staff General Conditions'){
						if(data.isGrandTotal) return true;
						row=this.d_collapsedProjectRoles.filter(t=>t.recordId==data.recordId)[0];
						if(row&&row.staffingDataId !=data.staffingDataId) return false;
						}

				return true;
			});	
			
		},
		c_reportCols() {
			// KT-Reports expects field/title/visible/datatype — use current view filter cols.
			// Type + Opportunity stay available for custom reports but off by default on Export.
			var omitDefault = { recordType: true, opportunity: true };
			var cols = (this.d_cols || []).map(function(c) {
				var offByDefault = !!omitDefault[c.field];
				return {
					field: c.field,
					title: c.title,
					visible: offByDefault ? false : c.visible !== false,
					datatype: c.datatype || "text",
					default: !offByDefault,
				};
			});
			// General Conditions: also export flattened monthly Staff $ columns (matches Gantt overlay)
			if (this.d_viewMode === "Project Staff General Conditions" && this.d_chartStartDate) {
				var monthCount = this.m_getMonthDiff() || 0;
				for (var i = 0; i < monthCount; i++) {
					var m = moment(this.d_chartStartDate).add(i, "months");
					cols.push({
						field: "monthCost_" + m.format("YYYY-MM"),
						title: m.format("MMM YYYY"),
						visible: true,
						datatype: "num",
						default: true,
					});
				}
			}
			return cols;
		},
		c_reportTableData() {
			var rows = this.c_filterStaffingData || [];
			var isGC = this.d_viewMode === "Project Staff General Conditions";
			if (this.d_viewMode === "Project Roles") {
				rows = rows.filter(function(r) {
					return !r.isProjectBar && !r.isProjectTotal && !r.isGrandTotal && r.roleId !== 0;
				});
			} else if (isGC) {
				// Keep role rows + project Total + Grand Total (what the GC view shows)
				rows = rows.filter(function(r) {
					if (r.isProjectTotal || r.isGrandTotal) return true;
					return !r.isProjectBar && r.roleId !== 0;
				});
			}
			return rows.map(function(r) {
				var row = Object.assign({}, r);
				if (r.isGrandTotal) {
					row.recordName = "Grand Total";
					row.projectName = "Grand Total";
					row.roleName = "";
					row.teamMemberName = "";
				} else if (r.isProjectTotal) {
					row.recordName = "Total";
					row.projectName = "Total";
					row.roleName = "";
					row.teamMemberName = "";
				} else {
					if (!row.projectName) row.projectName = row.recordName || row.project || "";
					if (!row.recordName) row.recordName = row.projectName || row.project || "";
					if (!row.teamMemberId && row.roleId) row.teamMemberName = "Needs To Be Filled";
				}
				if (isGC && row.monthlyCosts) {
					Object.keys(row.monthlyCosts).forEach(function(k) {
						row["monthCost_" + k] = row.monthlyCosts[k];
					});
				}
				return row;
			});
		},
		c_reportSort() {
			var field = this.d_sortColumn[this.d_viewMode];
			var dir = this.d_currentSort[this.d_viewMode] === -1 ? "desc" : "asc";
			if (!field) return [];
			return [{col: field, dir: dir}];
		},
		c_filterBarRows() {
			if(this.d_viewMode=='Project Roles' || this.d_viewMode=='Project Staff General Conditions'){
				return this.d_barRows.filter(barRow =>
					this.c_filterStaffingData.some(d => {
						if(d.isProjectBar || d.roleId===0 || d.isProjectTotal || d.isGrandTotal)
							return d.staffingDataId==barRow.staffingDataId;
						return d.roleRowKey && barRow.roleRowKey && d.roleRowKey==barRow.roleRowKey;
					})
				);
			}
			if(this.d_viewMode=='Team Members')
				return this.d_barRows.filter(data =>(this.c_filterStaffingData.filter(d=>d.staffingDataId==data.staffingDataId).length>0));
			return this.d_barRows.filter(data =>(this.c_filterStaffingData.filter(d=>d.teamMemberName==data.teamMemberName).length>0));
		}
	},
  methods: {
	m_scheduleRowHeightSync(){
		if(this._rowSyncFrame) return;
		this._rowSyncFrame = requestAnimationFrame(() => {
			this._rowSyncFrame = 0;
			if(this._isDestroyed) return;
			this.m_syncRowHeights();
		});
	},
	m_activeStaffingTable(){
		var ids = {
			"Team Members": "TeamMembers",
			"Project Roles": "ProjectRoles",
			"Project Staff General Conditions": "GeneralConditions",
			"Availability": "Availability",
		};
		var id = ids[this.d_viewMode];
		return id ? document.getElementById(id) : null;
	},
	/** Copy each visible table row height onto the matching Gantt and cost row.
	    Table rows grow when a project name wraps; the chart uses one fixed row height. */
	m_syncRowHeights(){
		if(!this.$el) return;
		var table = this.m_activeStaffingTable();
		if(!table) return;
		var bodyRows = table.querySelectorAll("tbody > tr");
		if(!bodyRows.length) return;
		var ganttRows = this.$el.querySelectorAll(".g-gantt-row");
		var costRows = this.$el.querySelectorAll(".chart-month-cost-row");
		for(var i = 0; i < bodyRows.length; i++){
			var h = bodyRows[i].getBoundingClientRect().height;
			if(!(h > 0)) continue;
			var px = h + "px";
			if(ganttRows[i]) ganttRows[i].style.setProperty("--staffing-row-h", px);
			if(costRows[i]) costRows[i].style.setProperty("--staffing-row-h", px);
		}
	},
	m_visibleTeamMember(data){ return 	this.c_filterStaffingData.filter(d=>d.teamMemberId==data.teamMemberId).length>1 &&
										this.d_staffingData.filter(d=>d.teamMemberId==data.teamMemberId).length>1;},
	m_notVisibleTeamMember(data){ return this.c_filterStaffingData.filter(d=>d.teamMemberId==data.teamMemberId).length==1 &&
										this.d_staffingData.filter(d=>d.teamMemberId==data.teamMemberId).length>1;},
	m_visibleProjectRole(data){ return 	this.c_filterStaffingData.filter(d=>d.recordId==data.recordId).length>1 &&
										this.d_staffingData.filter(d=>d.recordId==data.recordId).length>1;},
	m_notVisibleProjectRole(data){ return this.c_filterStaffingData.filter(d=>d.recordId==data.recordId).length==1 &&
										this.d_staffingData.filter(d=>d.recordId==data.recordId).length>1;},
	m_collapseTeamMembers(data){
								this.d_collapsedTeamMembers.push({teamMemberId:data.teamMemberId,staffingDataId:data.staffingDataId});
								},
	m_expandTeamMembers(data){	
								const index=this.d_collapsedTeamMembers.findIndex(t=>t.teamMemberId==data.teamMemberId&&t.staffingDataId==data.staffingDataId);
								this.d_collapsedTeamMembers.splice(index, 1); 
							},
	m_collapseProjectRoles(data){
								this.d_collapsedProjectRoles.push({recordId:data.recordId, staffingDataId:data.staffingDataId});
								},
	m_expandProjectRoles(data){	
								const index=this.d_collapsedProjectRoles.findIndex(t=>t.recordId==data.recordId&&t.staffingDataId==data.staffingDataId);
								this.d_collapsedProjectRoles.splice(index,1); 
							},								
	m_filterTableData(data) {
			console.log('d_filters');
			console.log(data);
			this.d_filters = {...data};
			// Make d_filter null if an empty filter.
			for (const key in this.d_filters) {
				if(this.d_filters[key] && this.d_filters[key].range &&(this.d_filters[key].min>0||this.d_filters[key].max>0))
					return ;
				else
				if(this.d_filters[key] && this.d_filters[key].date && (this.d_filters[key].min||this.d_filters[key].max))
					return;
				else
				if (this.d_filters[key] && this.d_filters[key].length) return;
				}
				
			this.d_filters=null;
	},
	m_closeChildWindow(){
			//this.d_componentKey++;
			document.getElementById("viewModeId").focus();
			},
	m_clearFilters(data){
			this.d_filters=null;
		},
	m_changeViewMode(){ 
						if(this.d_viewMode=='Team Members') {
						enableResizableTable("TeamMembers");
						this.d_filters=null;
						this.d_cols=[...this.d_teamMembers_cols];
						console.log('Team Members Data');
						console.log(this.d_teamMembersData);
						this.d_staffingData=[...this.d_teamMembersData];
						this.d_barRows=[...this.d_teamMembersBars];
						}
						if(this.d_viewMode=='Project Roles') {
							enableResizableTable("ProjectRoles");
							this.d_filters=null;
							this.d_cols=[...this.d_projectRoles_cols];
							console.log('Project Roles Data');
							console.log(this.d_projectRolesData);
							this.d_staffingData=[...this.d_projectRolesData];
							this.d_barRows=[...this.d_projectRolesBars];
						}
						if(this.d_viewMode=='Project Staff General Conditions') {
							enableResizableTable("GeneralConditions");
							this.d_filters=null;
							this.d_cols=[...this.d_generalConditions_cols];
							this.d_staffingData=[...this.d_generalConditionsData];
							this.d_barRows=[...this.d_generalConditionsBars];
						}
						if(this.d_viewMode=='Availability'){
							enableResizableTable("Availability");
							this.d_filters=null;
							this.d_cols=[...this.d_availability_cols];
							this.d_staffingData=[...this.d_availabilityData];
							this.d_barRows=[...this.d_availabilityBars];
						}
						this.$nextTick(() => {
							window.dispatchEvent(new Event("resize"));
						});
	},
	m_teamMemberChange(idx){
		var cur=this.c_filterStaffingData[idx];
		var prev=this.c_filterStaffingData[idx-1];
		if(!cur||!prev) return true;
		if(cur.teamMemberId!=null && prev.teamMemberId!=null)
			return cur.teamMemberId!=prev.teamMemberId;
		return cur.teamMemberName!=prev.teamMemberName;
	},
	m_projectNameChange(idx){ return this.c_filterStaffingData[idx].recordName != this.c_filterStaffingData[idx-1].recordName;},
	m_selectOpportunity(e){
						if(e){
						this.d_selectedRecord=e;
						this.d_selectedProject=null;
						} else this.d_selectedRecord=null;
	
	},
	m_selectProject(e){
						if(e){
							this.d_selectedRecord=e;
							this.d_selectedOpportunity=null;
						} else this.d_selectedRecord=null;
	},
    m_projectFilter(){
						if(this.d_recordType=='project') this.d_recordType=null
							else this.d_recordType='project';
						this.m_createChartRows();
					},
    m_opportunityFilter(){
						if(this.d_recordType=='opportunity') this.d_recordType=null
							else this.d_recordType='opportunity';
						this.m_createChartRows();
					},					
    getMonthText(idx) {
      if (idx > this.months.length - 1) idx = idx - this.months.length;
      return this.months[idx];
    },
	m_getMonthYear(month){
						let newDate=moment(this.d_chartStartDate).add(month,"months");
						return newDate.format("MMM-YYYY");
						},
	m_getMonthLabel(month){
						return moment(this.d_chartStartDate).startOf("month").add(month,"months").format("MMM");
						},
	/** Days of this chart month that fall inside the visible From–To range. */
	m_monthDaySpan(monthIndex){
		if(!this.d_chartStartDate || !this.d_chartEndDate) return 1;
		var chartStart=moment(this.d_chartStartDate);
		var chartEnd=moment(this.d_chartEndDate);
		var monthStart=chartStart.clone().startOf("month").add(monthIndex,"months");
		var monthEnd=monthStart.clone().add(1,"month");
		var segStart=moment.max(monthStart, chartStart);
		var segEnd=moment.min(monthEnd, chartEnd);
		var days=segEnd.diff(segStart,"days",true);
		return days>0?days:0;
	},
	m_dragBar(e){e.event.preventDefault();},
	m_dragStart(e){e.event.preventDefault();},
    m_stoppedDraggingBar(e) {
      console.log(e);
      e.event.preventDefault();
    },
    m_startDateChange(e) {
		this.dateFilter = "date";
		this.d_startDate=e+' 00:00:00';
    },
    m_endDateChange(e) {
      this.dateFilter = "date";
      this.d_endDate=e;
    },
    m_getYearDiff() {
	return new Date(this.d_chartEndDate).getFullYear()- new Date(this.d_chartStartDate).getFullYear();
    },
    m_getMonthDiff() {
	return fn_getMonthsDiff(new Date(this.d_chartStartDate),new Date(this.d_chartEndDate)); 
    },
    m_getMonth(date) {
      let d = moment(date);
      return d.month();
    },
    m_getYear(date) {
      let d = moment(date);
      return d.year();
    },
    m_refresh() {
            console.log('m_refresh');
            this.m_getStaffingData();
    },
	m_getStaffingData(){
		var today = new Date();
		if(!this.d_startDate) this.d_startDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0,10)+" 00:00:00";
		//if(!this.d_endDate) this.d_endDate = new Date(today.getFullYear(), 11, 31).toISOString().slice(0,10)+" 00:00:00";
		var startDate=new Date(today.getFullYear(), today.getMonth(), 1)
		if(!this.d_endDate) this.d_endDate = new Date(startDate.setMonth(startDate.getMonth() + 12)).toISOString().slice(0,10)+" 00:00:00";					
		let params={startDate:this.d_startDate, endDate:this.d_endDate};

		
		this.d_loading=true;
		// TEMPORARY: OFFLINE SAMPLE DATA
		//const loadFn = USE_SAMPLE_DATA ? fn_getSampleAllStaffingData : fn_getAllStaffingData;
		const loadFn = fn_getAllStaffingData;
		loadFn(params).then(resp => {
		if (resp.error || resp.errorMessage) {
			this.d_loading=false;
			return;
		} else {
		
					console.log('fn_getSampleAllStaffingData', resp);
					this.d_loading=false;
					this.d_dbStaffingData=resp.staffingData;
					console.log('d_dbStaffingData');
					console.log(this.d_dbStaffingData);
					this.d_recordType=null;
					this.d_roles=this.d_dbStaffingData.map(s=>s.roleName).filter((item,idx,arr)=>arr.indexOf(item)===idx);
					this.d_allOpportunities=this.d_dbStaffingData.filter(r=>r.recordType=='opportunity').map(s=>s.recordName).filter((item,idx,arr)=>arr.indexOf(item)===idx);
					this.d_allProjects=this.d_dbStaffingData.filter(r=>r.recordType=='project' || fn_isProjectHeaderRecord(r)).map(s=>s.recordName).filter((item,idx,arr)=>item && arr.indexOf(item)===idx);
					
					if(this.d_dbStaffingData.length){
						var minDate = Math.min(...this.d_dbStaffingData.filter(d=>d.startDate).map(d =>{ return new Date(d.startDate)}));
						var maxDate = Math.max(...this.d_dbStaffingData.filter(d=>d.endDate).map(d =>{ return new Date(d.endDate)}));

						if(!this.d_startDate) this.d_startDate=new Date(minDate).toISOString().slice(0,10)+" 00:00:00";
						if(!this.d_endDate) this.d_endDate=new Date(maxDate).toISOString().slice(0,10)+" 00:00:00";
								

			
						// Local calendar dates. toISOString() shifts the chart back a day in timezones ahead of UTC.
						this.d_chartStartDate=moment(this.d_startDate).startOf("month").format("YYYY-MM-DD HH:mm:ss");
						this.d_chartEndDate=moment(this.d_endDate).startOf("day").format("YYYY-MM-DD HH:mm:ss");

						// Fit the full date range in the visible Gantt column (no horizontal scroll)
						const chartContainer = document.getElementById("chartContainer");
						if (chartContainer) {
							chartContainer.style.minWidth = "100%";
							chartContainer.style.width = "100%";
						}
						this.$nextTick(() => {
							window.dispatchEvent(new Event("resize"));
						});

					this.m_create_teamMembersData();
					if(this.d_teamMembersData.length) {
						this.m_create_teamMembersBars();
						}
			
					this.m_create_projectRolesData();
					this.m_create_projectRolesBars();
					this.m_create_generalConditionsFromProjectRoles();
			
					this.m_create_availabilityData();
					if(this.d_availabilityData.length) {
						this.m_create_availabilityBars();
						console.log(this.d_availabilityBars);
						this.m_calculateAvailablePercent();
						console.log(this.d_availabilityData);
					}

					// Bind the active view after rebuild (preserves Project Roles / Availability on refresh)
					this.m_changeViewMode();
			}
		}
			
	});
},
	m_viewModal(recNo){kbdpRecord.showRecord('team', recNo);},
	m_barAllocLabel(bar){
		// Project header bars (roleId===0) keep project name; only role allocation bars show %
		if(!bar || bar.roleId===0 || bar.recordType==='available') return null;
		var pct=bar.timePercent!=null && bar.timePercent!=='' ? bar.timePercent : (bar.ganttBarConfig&&bar.ganttBarConfig.timePercent);
		if(pct==null || pct==='') return null;
		return pct+'%';
	},
	m_barTitle(bar){
		if(!bar) return '';
		var label=(bar.ganttBarConfig&&bar.ganttBarConfig.label)||'';
		var parts=[];
		if(this.c_isProjectRolesLike){
			var alloc=this.m_barAllocLabel(bar);
			if(label && alloc) parts.push(label+' — '+alloc);
			else if(alloc) parts.push(alloc);
			else if(label) parts.push(label);
		} else if(label) {
			parts.push(label);
		}
		if(bar.precon || (bar.ganttBarConfig&&bar.ganttBarConfig.precon)) parts.push('Precon');
		else if((bar.roleId===0 || bar.isProjectBar) && fn_isPreconProjectStatus(bar)) parts.push('Project Status: Precon');
		return parts.join(' · ');
	},
	m_barLabelColor(bar){
		if(this.d_viewMode==='Team Members') return '#ffffff';
		return (bar && bar.ganttBarConfig && bar.ganttBarConfig.color) || '#ffffff';
	},
	m_teamMemberInitials(name){
		if(!name) return '?';
		const parts=String(name).trim().split(/\s+/).filter(Boolean);
		if(!parts.length) return '?';
		if(parts.length===1) return parts[0].slice(0,2).toUpperCase();
		return (parts[0][0]+parts[parts.length-1][0]).toUpperCase();
	},
	m_teamMemberPhoto(row){
		if(!row || !row.teamMemberId) return null;
		if(row.photoURL) return row.photoURL;
		// TEMPORARY: OFFLINE SAMPLE DATA — local dummy photos instead of API profilePicture
		//if(USE_SAMPLE_DATA) return fn_sampleProfilePicURL(row.teamMemberId);
		return fn_profilePicURL(row.teamMemberId);
	},
	m_titleColor(roleName){
		const key=String(roleName||"").toLowerCase().trim();
		if(!key) return "#495057";
		const known={
			"project executive":"#0d6efd",
			"project manager":"#198754",
			"senior estimator":"#fd7e14",
			"estimator":"#e35d00",
			"superintendent":"#6f42c1",
			"assistant project manager":"#0dcaf0",
			"project engineer":"#20c997",
			"architect":"#6610f2",
			"designer":"#d63384",
			"foreman":"#dc3545",
		};
		if(known[key]) return known[key];
		const palette=["#0d6efd","#198754","#fd7e14","#6f42c1","#dc3545","#20c997","#6610f2","#d63384","#0dcaf0","#e35d00"];
		let hash=0;
		for(let i=0;i<key.length;i++) hash=key.charCodeAt(i)+((hash<<5)-hash);
		return palette[Math.abs(hash)%palette.length];
	},
	m_photoError(item){
		if(!item) return;
		this.$set(item,'photoFailed',true);
	},
	m_sortClick(e,col) {
	
		var sortType=this.d_currentSort[this.d_viewMode]*-1;
		this.d_currentSort[this.d_viewMode]=sortType;
		this.d_sortColumn[this.d_viewMode]=col;
		
		
		if(this.d_viewMode=='Team Members') {
			this.d_cols=[...this.d_teamMembers_cols];
			this.d_teamMembersData=[...this.m_sort(this.d_teamMembersData,col)];
			this.m_create_teamMembersBars();
			this.d_staffingData=[...this.d_teamMembersData];
			this.d_barRows=[...this.d_teamMembersBars];
		}
			
			
		if(this.d_viewMode=='Project Roles') {
			this.d_cols=[...this.d_projectRoles_cols];
			this.m_create_projectRolesData();
			this.m_create_projectRolesBars();
			this.m_create_generalConditionsFromProjectRoles();
			this.d_staffingData=[...this.d_projectRolesData];
			this.d_barRows=[...this.d_projectRolesBars];
		}

		if(this.d_viewMode=='Project Staff General Conditions') {
			this.d_cols=[...this.d_generalConditions_cols];
			this.m_create_projectRolesData();
			this.m_create_projectRolesBars();
			this.m_create_generalConditionsFromProjectRoles();
			this.d_staffingData=[...this.d_generalConditionsData];
			this.d_barRows=[...this.d_generalConditionsBars];
		}
		
		if(this.d_viewMode=='Availability') {
			this.d_cols=[...this.d_availability_cols];
			this.d_availabilityData=[...this.m_sort(this.d_availabilityData,col)];
			this.m_create_availabilityBars();
			this.d_staffingData=[...this.d_availabilityData];
			this.d_barRows=[...this.d_availabilityBars];
			
			console.log('this.d_availabilityData',this.d_availabilityData);
			console.log('this.d_availabilityBars','this.d_availabilityBars');
			
		}
		
					
        //window.localStorage.setItem(window.location.href+'-sortColumn',JSON.stringify({field:col.field,sortType:sortType*-1}));	

		},
		
		m_sort(data, field){
		
	
		
		var ac;
		var bc;
		
		var sortType=this.d_currentSort[this.d_viewMode];
		var col=this.d_cols.filter(c=>c.field==field)[0];
		var groupByMember=this.d_viewMode==='Team Members';
		
	
		
		data.sort((a, b) => {
				// Keep all assignments for a person together (name shown once; expand/collapse works)
				if(groupByMember){
					var aName=(a.teamMemberName||'').toUpperCase();
					var bName=(b.teamMemberName||'').toUpperCase();
					if(aName!==bName){
						if(field==='teamMemberName'){
							if(aName<bName) return -1*sortType;
							return sortType;
						}
						if(aName<bName) return -1;
						return 1;
					}
					if(field==='teamMemberName'){
						// Same person — secondary by start date
						var aStart=a.startDate?new Date(a.startDate):0;
						var bStart=b.startDate?new Date(b.startDate):0;
						if(aStart===bStart) return 0;
						return aStart<bStart?-1:1;
					}
				}
				
				if(col.datatype=='date'){
					ac = a[field]?new Date(a[field]):0;
					bc = b[field]?new Date(b[field]):0;
				} else if(col.datatype=='num'){
					ac = a[field];
					bc = b[field];
				} else {					
					ac = a[field]?a[field].toUpperCase():' ';
					bc = b[field]?b[field].toUpperCase():' ';
					}
					
				if(ac==bc) return 0;
				if(ac<bc)  return -1*sortType;
				return sortType;
			});
			
	
		return data;
  },
m_create_teamMembersData(){
	
		let staffingData=[];
		let sdRows=[];
		this.d_rowHeight=48;


		staffingData=this.d_dbStaffingData.filter(sd=>sd.staffingDataId&&sd.teamMemberId&&(sd.recordType=='opportunity'||sd.recordType=='project'));
		console.log(staffingData);
		staffingData.forEach((row,idx)=>{

			let sdRow=row;
			sdRow.startDate=new Date(sdRow.startDate)<new Date(this.d_startDate)?new Date(this.d_startDate).toISOString().slice(0,10):sdRow.startDate;
			sdRow["label"]=row.recordNo+':'+row.recordName;
			if(row.timePercent) sdRow["label"]=`${row.recordNo}:${row.recordName}(${row.timePercent}%)`;
			sdRow["link"]=this.d_linkFn(row.recordType=='opportunity'?'oppr':'proj',row.recordNo);
			sdRow["teamMemberLink"]=this.d_linkFn('team',row.teamMemberNo);
			sdRow["image"]=this.m_teamMemberPhoto(row);
			sdRow["photoFailed"]=false;
			sdRow["opportunity"]=row.recordType=='opportunity'?row.recordName:null;
			sdRow["project"]=row.recordType=='project'?row.recordName:null;

			sdRows.push(sdRow);
			});

	// Group by team member so the name cell renders once (continuation rows blank)
	sdRows.sort((a,b)=>{
		var aName=(a.teamMemberName||'').toUpperCase();
		var bName=(b.teamMemberName||'').toUpperCase();
		if(aName!==bName) return aName<bName?-1:1;
		var aStart=a.startDate?new Date(a.startDate):0;
		var bStart=b.startDate?new Date(b.startDate):0;
		if(aStart===bStart) return 0;
		return aStart<bStart?-1:1;
	});
			
	console.log(sdRows);			
	this.d_teamMembersData=[...sdRows];
	},
m_create_teamMembersBars(){
	this.d_teamMembersBars.length=0;
	// One bar-row per assignment, in same order as table (grouped under each member)
	this.d_teamMembersData.forEach(m=>{this.d_teamMembersBars=this.d_teamMembersBars.concat(fn_add_barRow([m]));});
	},
m_create_projectRolesData(){
	var staffingData=[];
	var projectRoles=[];
	var projectRole;
    var arrayIdx;	
	var projectName;
	var teamMemberLink;
	var image;
	let sortType=this.d_currentSort[this.d_viewMode];
	this.d_rowHeight=48;
		
	staffingData=this.d_dbStaffingData.filter(fn_isProjectStaffingRow);
	var projectHeaders=(this.d_dbStaffingData||[]).filter(fn_isProjectHeaderRecord);

		
	staffingData.forEach(row=>{
								
									row.startDate=new Date(row.startDate)<new Date(this.d_startDate)?new Date(this.d_startDate).toISOString().slice(0,10):row.startDate;
									row["label"]=row.recordNo+':'+row.recordName;
									var link=this.d_linkFn('proj',row.recordNo);
									row["link"]=link;
									image=null;
									teamMemberLink=null;
									if(row.teamMemberId){
										teamMemberLink=this.d_linkFn('team',row.teamMemberNo);
										image=this.m_teamMemberPhoto(row);
										row["image"]=image;
										row["photoFailed"]=false;
										}
									
									projectName=row.recordName;
									// One line per project + role + team member (do not merge different people)
									var roleRowKey=fn_projectRoleRowKey(row);
									var periodMonths=fn_periodDurationMonths(row.startDate,row.endDate);
									var periodPct=row.timePercent!=null && row.timePercent!=='' ? Number(row.timePercent) : 0;
									projectRole={ 
												recordId:row.recordId,
												staffingDataId:row.staffingDataId,
												roleRowKey:roleRowKey,
												recordNo:row.recordNo,
												recordName:row.recordName,
												project:row.recordName,
												projectName:projectName,
												opportunity:null,
												roleId:row.roleId,
												roleName:row.roleName,
												teamMemberId:row.teamMemberId,
												teamMemberNo:row.teamMemberNo,
												teamMemberName:row.teamMemberName,
												startDate:row.startDate,
												endDate:row.endDate,
												timePercent:row.timePercent,
												periodCount:1,
												allocDuration:periodMonths,
												allocEffort:periodPct*periodMonths,
												link:link,
												teamMemberLink:teamMemberLink,
												image:image,
												photoFailed:false,
												projectStatusId:row.projectStatusId,
												projectStatusName:row.projectStatusName,
												recordType:'project',
												isProjectBar:false};
												// Periods for the same role + member share the line
												arrayIdx=projectRoles.findIndex(r=>r.roleRowKey==projectRole.roleRowKey);
												if(arrayIdx==-1){
													projectRoles.push(projectRole);
												} else {
													var existing=projectRoles[arrayIdx];
													existing.periodCount=(existing.periodCount||1)+1;
													existing.allocDuration=(existing.allocDuration||0)+periodMonths;
													existing.allocEffort=(existing.allocEffort||0)+(periodPct*periodMonths);
													// Duration-weighted Alloc %: sum(pct × months) / sum(months)
													if(existing.allocDuration>0){
														existing.timePercent=Math.round((existing.allocEffort/existing.allocDuration)*100)/100;
													}
												}
		});
		
				
		projectRoles.sort((a,b)=>{	
			var aVal=(a.recordName||'')+(a.roleName||'ZZ')+(a.teamMemberName||'ZZ');
			var bVal=(b.recordName||'')+(b.roleName||'ZZ')+(b.teamMemberName||'ZZ');
			return (aVal > bVal) ? sortType : -1*sortType;
		});

		// Header bar comes from the projectHeader record (its own start/end).
		// Role rows stay underneath. No header is invented from staff dates.
		var groups=[];
		var groupByKey={};
		var projectKey=function(row){
			if(row.recordId!=null && row.recordId!=='') return 'id:'+row.recordId;
			return 'name:'+(row.recordName||'');
		};
		var ensureGroup=(row)=>{
			var key=projectKey(row);
			if(!groupByKey[key]){
				groupByKey[key]={key:key, name:row.recordName||'', header:null, roles:[]};
				groups.push(groupByKey[key]);
			}
			return groupByKey[key];
		};
		var headersFor=function(row){
			return projectHeaders.filter(h=>{
				if(row.recordId!=null && h.recordId!=null && String(h.recordId)===String(row.recordId)) return true;
				return !!(row.recordName && h.recordName && h.recordName===row.recordName);
			});
		};
		var pickHeader=function(matches){
			if(!matches || !matches.length) return null;
			var typed=matches.find(h=>fn_recordTypeKey(h)==='projectheader');
			return typed || matches[0];
		};
		projectRoles.forEach(row=>{
			var group=ensureGroup(row);
			group.roles.push(row);
			if(!group.header) group.header=pickHeader(headersFor(row));
		});
		projectHeaders.forEach(h=>{
			var group=ensureGroup(h);
			if(!group.header) group.header=pickHeader(headersFor(h));
		});
		groups.sort((a,b)=>{
			return (a.name>b.name) ? sortType : (a.name<b.name ? -1*sortType : 0);
		});

		var withProjectBars=[];
		groups.forEach(group=>{
			var header=group.header;
			if(header){
				var fallback=group.roles[0]||null;
				var startStr=header.startDate;
				if(startStr && new Date(startStr)<new Date(this.d_startDate))
					startStr=new Date(this.d_startDate).toISOString().slice(0,10);
				var sid=header.staffingDataId;
				if(sid==null || sid==='' || sid===0 || sid==='0') sid='project-bar-'+header.recordId;
				withProjectBars.push({
					recordId:header.recordId,
					staffingDataId:sid,
					recordNo:header.recordNo,
					recordName:header.recordName,
					project:header.recordName,
					projectName:header.recordName,
					opportunity:null,
					roleId:0,
					roleName:null,
					teamMemberId:null,
					teamMemberName:null,
					teamMemberNo:null,
					startDate:startStr,
					endDate:header.endDate,
					timePercent:null,
					link:(fallback && fallback.link) || this.d_linkFn('proj', header.recordNo),
					teamMemberLink:null,
					image:null,
					photoFailed:false,
					isProjectBar:true,
					label:(header.recordNo?header.recordNo+':':'')+(header.recordName||''),
					recordType:'project',
					projectStatusId:header.projectStatusId!=null ? header.projectStatusId : (fallback && fallback.projectStatusId),
					projectStatusName:header.projectStatusName || (fallback && fallback.projectStatusName) || null,
				});
			}
			group.roles.forEach(row=>{ withProjectBars.push(row); });
		});

		this.d_projectRolesData=[...withProjectBars];
	
	},
m_create_projectRolesBars(){
	this.d_projectRolesBars.length=0;
	var staffingData=this.d_dbStaffingData.filter(fn_isProjectStaffingRow);
	this.d_projectRolesData.forEach(row=>{
							if(row.isProjectBar || row.roleId===0){
								var projectBarRow={
									...row,
									recordType:'project',
									roleId:0,
									timePercent:null,
									label:row.label || ((row.recordNo?row.recordNo+':':'')+row.recordName),
									link:row.link,
								};
								var projectBars=fn_add_barRow([projectBarRow]);
								projectBars.forEach(br=>{ br.roleRowKey=row.staffingDataId; });
								this.d_projectRolesBars=this.d_projectRolesBars.concat(projectBars);
								return;
							}
							// Periods for this role + team member only (never merge other people or opportunities)
							var roleStaffData=staffingData.filter(s=>fn_projectRoleRowKey(s)==row.roleRowKey);
							roleStaffData.sort((a,b)=>new Date(a.startDate)-new Date(b.startDate));
							roleStaffData=roleStaffData.map(s=>({
								...s,
								label:s.label || ((s.recordNo?s.recordNo+':':'')+s.recordName+(s.timePercent?'('+s.timePercent+'%)':'')),
								link:row.link || s.link,
							}));
							if(roleStaffData.length){
								var roleBars=fn_add_barRow(roleStaffData);
								roleBars.forEach(br=>{ br.roleRowKey=row.roleRowKey; });
								this.d_projectRolesBars=this.d_projectRolesBars.concat(roleBars);
							}
						});
	},
	/** Clone Project Roles rows/bars and attach Staff $ + weekday-prorated monthly costs. */
	m_create_generalConditionsFromProjectRoles(){
		var staffingData=this.d_dbStaffingData.filter(fn_isProjectStaffingRow);
		var chartStart=this.d_chartStartDate;
		var chartEnd=this.d_chartEndDate;
		var enriched=(this.d_projectRolesData||[]).map(row=>{
			var copy=Object.assign({}, row);
			if(row.isProjectBar || row.roleId===0 || !row.roleRowKey){
				copy.staffCost=null;
				copy.monthlyCosts={};
				return copy;
			}
			var periods=staffingData.filter(s=>fn_projectRoleRowKey(s)===row.roleRowKey);
			copy.staffCost=fn_staffCostForPeriods(periods);
			copy.monthlyCosts=fn_mergeMonthlyCosts(periods, chartStart, chartEnd);
			return copy;
		});

		// Insert a Total row after each project's staff lines, then a Grand Total at the end
		var withTotals=[];
		var projectStaffRows=[];
		var flushProjectTotal=function(){
			if(!projectStaffRows.length) return;
			var monthly={};
			var staffCost=0;
			var any=false;
			var first=projectStaffRows[0];
			projectStaffRows.forEach(function(r){
				if(r.staffCost!=null && r.staffCost!=='' && !isNaN(parseFloat(r.staffCost))){
					staffCost+=parseFloat(r.staffCost);
					any=true;
				}
				Object.keys(r.monthlyCosts||{}).forEach(function(k){
					monthly[k]=fn_roundMoney((monthly[k]||0)+parseFloat(r.monthlyCosts[k]||0));
				});
			});
			withTotals.push({
				recordId:first.recordId,
				staffingDataId:'project-total-'+first.recordId,
				roleRowKey:'project-total-'+first.recordId,
				recordNo:first.recordNo,
				recordName:first.recordName,
				project:first.recordName,
				projectName:first.projectName,
				opportunity:null,
				roleId:null,
				roleName:null,
				teamMemberId:null,
				teamMemberName:null,
				teamMemberNo:null,
				staffCost:any ? fn_roundMoney(staffCost) : null,
				monthlyCosts:monthly,
				link:first.link,
				teamMemberLink:null,
				image:null,
				photoFailed:false,
				isProjectBar:false,
				isProjectTotal:true,
				isGrandTotal:false,
				recordType:'project',
			});
		};
		enriched.forEach(function(row){
			if(row.isProjectBar || row.roleId===0){
				flushProjectTotal();
				projectStaffRows=[];
				withTotals.push(row);
				return;
			}
			withTotals.push(row);
			projectStaffRows.push(row);
		});
		flushProjectTotal();

		var grandMonthly={};
		var grandCost=0;
		var anyGrand=false;
		withTotals.forEach(function(r){
			if(!r.isProjectTotal) return;
			if(r.staffCost!=null && r.staffCost!=='' && !isNaN(parseFloat(r.staffCost))){
				grandCost+=parseFloat(r.staffCost);
				anyGrand=true;
			}
			Object.keys(r.monthlyCosts||{}).forEach(function(k){
				grandMonthly[k]=fn_roundMoney((grandMonthly[k]||0)+parseFloat(r.monthlyCosts[k]||0));
			});
		});
		withTotals.push({
			recordId:null,
			staffingDataId:'grand-total',
			roleRowKey:'grand-total',
			recordNo:null,
			recordName:'Grand Total',
			project:'Grand Total',
			projectName:'Grand Total',
			opportunity:null,
			roleId:null,
			roleName:null,
			teamMemberId:null,
			teamMemberName:null,
			teamMemberNo:null,
			staffCost:anyGrand ? fn_roundMoney(grandCost) : null,
			monthlyCosts:grandMonthly,
			link:null,
			teamMemberLink:null,
			image:null,
			photoFailed:false,
			isProjectBar:false,
			isProjectTotal:false,
			isGrandTotal:true,
			recordType:'project',
		});

		this.d_generalConditionsData=withTotals;

		// Bars aligned 1:1 with table rows (empty bar lanes for total rows)
		var prBars=this.d_projectRolesBars||[];
		var bars=[];
		withTotals.forEach(function(row){
			if(row.isProjectTotal || row.isGrandTotal){
				bars.push({
					staffingDataId:row.staffingDataId,
					roleRowKey:row.roleRowKey,
					recordId:row.recordId,
					recordName:row.recordName,
					roleId:null,
					isProjectTotal:!!row.isProjectTotal,
					isGrandTotal:!!row.isGrandTotal,
					teamMemberName:null,
					bars:[],
				});
				return;
			}
			var br=null;
			if(row.isProjectBar || row.roleId===0){
				br=prBars.find(function(b){ return b.staffingDataId===row.staffingDataId; });
			} else if(row.roleRowKey){
				br=prBars.find(function(b){ return b.roleRowKey===row.roleRowKey; });
			}
			if(br) bars.push(JSON.parse(JSON.stringify(br)));
		});
		this.d_generalConditionsBars=bars;
	},
	m_gcRowClass(item){
		if(!item) return 'rowStyle';
		if(item.isGrandTotal) return 'rowStyle staffing-gc-total-row staffing-gc-grand-total-row';
		if(item.isProjectTotal) return 'rowStyle staffing-gc-total-row';
		return 'rowStyle';
	},
	m_costFormat(value){
		if(value==null || value==='' || isNaN(parseFloat(value))) return '';
		return '$'+Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {
			minimumFractionDigits:2,
			maximumFractionDigits:2,
		});
	},
	m_gcMonthKey(monthIndex){
		return moment(this.d_chartStartDate).add(monthIndex,'months').format('YYYY-MM');
	},
	m_gcMonthCost(row, monthIndex){
		if(!row || row.isHeader || !row.monthlyCosts) return null;
		var key=this.m_gcMonthKey(monthIndex);
		var amt=row.monthlyCosts[key];
		if(amt==null || amt==='' || isNaN(parseFloat(amt)) || parseFloat(amt)===0) return null;
		return parseFloat(amt);
	},
m_create_availabilityData(){
	
	let staffingData=[];
	this.d_rowHeight=48;
	staffingData=this.d_dbStaffingData.filter(d=>d.teamMemberId&&d.recordType=='project');
		
		
		//Get unique team Members
		var teamMembers=[];
		var teamMember;
		staffingData.forEach(s=>{if(s.teamMemberName){
									teamMember={teamMemberId:s.teamMemberId,
											teamMemberNo:s.teamMemberNo,
											teamMemberName:s.teamMemberName,
											teamMemberLink:this.d_linkFn('team',s.teamMemberNo),
											position:s.position,
											photoURL:s.photoURL,
											image:this.m_teamMemberPhoto(s),
											photoFailed:false,
											availablePercent:s.availablePercent?s.availablePercent:0,
											};
								if(teamMembers.findIndex(m=>m.teamMemberId==teamMember.teamMemberId)==-1) teamMembers.push(teamMember);
								}
								});
	
	this.d_availabilityData=[...teamMembers];	

	},
m_create_availabilityBars(){
	this.d_rowHeight=48;
	var allMembersBars=[];
	var allMembersAvailabilities=[];
	var count;
	var staffingData=this.d_dbStaffingData.filter(d=>d.teamMemberId&&d.recordType=='project');
	this.d_availabilityData.forEach(m=>{
									
			var memberData=staffingData.filter(s=>s.teamMemberName==m.teamMemberName).map(t=>{
					return {teamMemberName:t.teamMemberName,
							recordType:t.recordType,
							recordName:t.recordName,
							recordNo:t.recordNo,
							position:t.position,
							startDate:new Date(t.startDate)<new Date(this.d_startDate)?new Date(this.d_startDate).toISOString().slice(0,10):t.startDate,
							endDate:t.endDate,
							timePercent:t.timePercent,
							label:t.timePercent?t.recordNo+':'+t.recordName+"("+t.timePercent+"%)":t.recordNo+':'+t.recordName,
							link:this.d_linkFn(t.recordType=='opportunity'?'oppr':'proj',t.recordNo)
							};
			});
			
			
																					
			var memberAvailabilities=[];
			var availabilityRec={};
			//sort by StartDate
			memberData.sort((a,b)=>{
				return new Date(a.startDate) > new Date(b.startDate) ? 1 : -1;
			});
									


								
			var startDate;
			var endDate;
			var previousStartDate;
			var previousEndDate;
			var maxEndDate;
			var previous;
									
			memberData.forEach((d,idx)=>{
			console.log(`${d.teamMemberName} start ${d.startDate} End ${d.endDate}`);
			
								
												if(idx==0){
														previousStartDate=this.d_startDate;
														maxEndDate=d.endDate;
														if(!d.startDate&&!d.endDate){
															availabilityRec={};
															availabilityRec["teamMemberName"]=d.teamMemberName;
															availabilityRec["recordType"]='available';
															availabilityRec["position"]=d.position;
															availabilityRec["startDate"]=moment(this.d_startDate).format('YYYY-MM-DD');
															availabilityRec["endDate"]=moment(this.d_endDate).format('YYYY-MM-DD');
															availabilityRec["label"]='Free:'+moment(availabilityRec.startDate).format('MMM DD, YYYY')+'-'+moment(availabilityRec.endDate).format('MMM DD, YYYY');
															memberAvailabilities.push(availabilityRec);
															}
														if(new Date(d.startDate)>new Date(this.d_startDate)){
															availabilityRec={};
															availabilityRec["teamMemberName"]=d.teamMemberName;
															availabilityRec["position"]=d.position;
															availabilityRec["recordType"]='available';
															availabilityRec["startDate"]=moment(this.d_startDate).format('YYYY-MM-DD');
															availabilityRec["endDate"]=moment(d.startDate).subtract(1,'d').format('YYYY-MM-DD');
															availabilityRec["label"]='Free:'+moment(availabilityRec.startDate).format('MMM DD, YYYY')+'-'+moment(availabilityRec.endDate).format('MMM DD, YYYY');
															memberAvailabilities.push(availabilityRec);
														}
													} else{
															previousEndDate=memberData[idx-1].endDate;
															if(!d.startDate&&!d.endDate){
																availabilityRec={};
																availabilityRec["teamMemberName"]=d.teamMemberName;
																availabilityRec["position"]=d.position;
																availabilityRec["recordType"]='available';
																availabilityRec["startDate"]=moment(this.d_startDate).format('YYYY-MM-DD');
																availabilityRec["endDate"]=moment(this.d_endDate).format('YYYY-MM-DD');
																availabilityRec["label"]='Free:'+moment(availabilityRec.startDate).format('MMM DD, YYYY')+'-'+moment(availabilityRec.endDate).format('MMM DD, YYYY');
																memberAvailabilities.push(availabilityRec);
															} else {															
																if(new Date(d.startDate)>new Date(maxEndDate)){
																	availabilityRec={};
																	availabilityRec["teamMemberName"]=d.teamMemberName;
																	availabilityRec["position"]=d.position;
																	availabilityRec["recordType"]='available';
																	availabilityRec["startDate"]=moment(maxEndDate).add(1,'d').format('YYYY-MM-DD');
																	availabilityRec["endDate"]=moment(d.startDate).subtract(1,'d').format('YYYY-MM-DD');
																	availabilityRec["label"]='Free:'+moment(availabilityRec.startDate).format('MMM DD, YYYY')+'-'+moment(availabilityRec.endDate).format('MMM DD, YYYY');
																	memberAvailabilities.push(availabilityRec);
																}
															}
															
															var n_endDate=new Date(d.endDate);															var new_endDate=new Date(d.endDate);
															var m_endDate=new Date(maxEndDate);
															if(n_endDate>m_endDate) maxEndDate=d.endDate;
													}

										
				});
									
					count=memberData.length;
					var d=memberData[count-1];
					
					console.log(`${d.teamMemberName} end with start ${d.startDate} End ${d.endDate} Max ${maxEndDate}`);
					if(d&&(new Date(maxEndDate)<new Date(this.d_endDate))){
						availabilityRec={};
						availabilityRec["teamMemberName"]=d.teamMemberName;
						availabilityRec["position"]=d.position;
						availabilityRec["recordType"]='available';
						availabilityRec["startDate"]=moment(maxEndDate).add(1,'d').format('YYYY-MM-DD');
						availabilityRec["endDate"]=moment(this.d_endDate).format('YYYY-MM-DD');
						availabilityRec["label"]='Free:'+moment(availabilityRec.startDate).format('MMM DD, YYYY')+'-'+moment(availabilityRec.endDate).format('MMM DD, YYYY');
						memberAvailabilities.push(availabilityRec);										  
						}
					
						console.log('memberAvailabilities');
						console.log(memberAvailabilities);
						memberData=memberData.concat(memberAvailabilities);
						//allMembersBars=allMembersBars.concat(fn_add_barRow(memberData));
						var memberBars=fn_add_barRow(memberData);
						//var availablePercent=this.m_availablePercent(m.teamMemberName,memberBars);
						//m.availablePercent=availablePercent;
						allMembersBars=allMembersBars.concat(memberBars);
						allMembersAvailabilities=allMembersAvailabilities.concat(memberData);
						
				});
		
		this.d_availabilityBars=[...allMembersBars];
	
},
m_calculateAvailablePercent(){
		this.d_availabilityData.forEach(a=>{
			var availabilityBars=this.d_availabilityBars.filter(b=>b.teamMemberName==a.teamMemberName)[0];
			a.availablePercent=this.m_availablePercent(availabilityBars);
		});			
},
m_availablePercent(availabilityBars){

	
		var workingDays=0;
		var availableDays=0;
		var totalDays=0;
		var timePercent=0;
		var startDate;
		var endDate;
		var availablePercent;
		availabilityBars.bars.forEach(d=>{
			if(d.endDate && d.startDate) {
				startDate=moment(d.startDate)<moment(this.d_startDate)?this.d_startDate:d.startDate;
				endDate=moment(d.endDate)<moment(this.d_endDate)?d.endDate:this.d_endDate;
				timePercent=d.timePercent?d.timePercent:100;
				workingDays=fn_getWorkingDays(endDate, startDate);
				totalDays=totalDays+workingDays;
				if(d.recordType=='available') availableDays=availableDays+workingDays;
				else availableDays=availableDays+workingDays*(100-timePercent)/100;
				console.log(`working days ${workingDays} total days ${totalDays} vailable days ${availableDays}`);
				}
		});
		availablePercent=Math.round(availableDays/totalDays*10000)/100;	
		return availablePercent;
	},
  },	
  watch: {},
};

function fn_recordTypeKey(sd){
	return String((sd && sd.recordType) || '').toLowerCase().replace(/[\s_-]/g,'');
}
/** Project span already supplied with staffing data (recordType projectHeader, or the roleId 0 header row). */
function fn_isProjectHeaderRecord(sd){
	if(!sd || sd.recordId==null || sd.recordId==='') return false;
	if(sd.removed && sd.removed!=0) return false;
	if(fn_recordTypeKey(sd)==='projectheader') return true;
	var isProject=fn_recordTypeKey(sd)==='project' || sd.recordContext==='projectId';
	var zeroRole=sd.roleId===0 || sd.roleId==='0';
	var zeroSid=sd.staffingDataId==null || sd.staffingDataId==='' || sd.staffingDataId===0 || sd.staffingDataId==='0';
	return isProject && zeroRole && zeroSid && !sd.roleName;
}
/** Project Roles view — project staffing only (exclude opportunity rows and the project header). */
function fn_isProjectStaffingRow(sd){
	if(!sd || !sd.recordId) return false;
	if(sd.removed && sd.removed!=0) return false;
	if(fn_isProjectHeaderRecord(sd)) return false;
	// Never opportunity
	if(String(sd.recordType||'').toLowerCase()==='opportunity') return false;
	if(sd.recordContext==='opportunityId') return false;
	if(sd.recordNo && /^OPP-/i.test(String(sd.recordNo))) return false;
	// Must affirmatively identify as project
	return String(sd.recordType||'').toLowerCase()==='project'
		|| sd.recordContext==='projectId'
		|| /^PRJ-/i.test(String(sd.recordNo||''));
}
/** One Gantt/table line per project + role + team member (blank = unfilled). */
function fn_projectRoleRowKey(row){
	var rolePart=row.roleId!=null?row.roleId:row.roleName;
	var tmPart=row.teamMemberId!=null && row.teamMemberId!=='' ? ('tm:'+row.teamMemberId) : 'tm:blank';
	return row.recordId+'|'+rolePart+'|'+tmPart;
}
/** True when project status is Precon (Project Roles header bar color). */
function fn_isPreconProjectStatus(row){
	if(!row) return false;
	var name=String(row.projectStatusName||row.statusName||'').toLowerCase().trim();
	if(name==='precon' || name==='pre-con' || name==='preconstruction') return true;
	return false;
}
function fn_getMonthsDiff(startDate, endDate) {
		//return endDate.getMonth() - startDate.getMonth() + (12 * (endDate.getFullYear() - startDate.getFullYear())+1);
		return Math.ceil(moment(endDate).diff(startDate, 'months', true));

	}
/** Inclusive-ish month span for weighted Alloc % (e.g. Oct 1–Mar 31 ≈ 6 months). */
function fn_periodDurationMonths(startDate, endDate) {
	if(!startDate || !endDate) return 0;
	var months=moment(endDate).add(1,'day').diff(moment(startDate),'months',true);
	return months>0 ? months : 0;
}
function fn_getDaysDiff(startDate, endDate) {
		return moment(endDate).diff(startDate, 'days', true);
	}
function fn_validDateMs(value) {
	if (value == null || value === '') return NaN;
	const t = new Date(value).getTime();
	return Number.isFinite(t) ? t : NaN;
}
function fn_isoDateOnly(value) {
	const t = typeof value === 'number' ? value : fn_validDateMs(value);
	if (!Number.isFinite(t)) return null;
	return new Date(t).toISOString().slice(0, 10);
}
/**
 * Replace vue-ganttastic's fixed 5.53px-per-day placement.
 * Bars use the same day scale as the month headers in this component.
 */
function fn_patchGanttBarScale(GGanttRow) {
	var bar = GGanttRow && GGanttRow.components && GGanttRow.components.GGanttBar;
	if (!bar || !bar.methods || bar.methods._kbdpBarScale) return;
	bar.methods._kbdpBarScale = true;
	bar.methods.mapTimeToPosition = function(time) {
		var chartStart = this.chartStartMoment;
		var chartEnd = this.chartEndMoment;
		var totalMs = chartEnd.valueOf() - chartStart.valueOf();
		var width = this.barContainer && this.barContainer.width ? this.barContainer.width : 0;
		var timeMs = moment(time).valueOf();
		if (!totalMs || !width || !isFinite(timeMs)) return 0;
		var ratio = (timeMs - chartStart.valueOf()) / totalMs;
		if (ratio < 0) ratio = 0;
		if (ratio > 1) ratio = 1;
		return ratio * width;
	};
	bar.methods.mapPositionToTime = function(xPos) {
		var width = this.barContainer && this.barContainer.width ? this.barContainer.width : 0;
		var chartStart = this.chartStartMoment;
		var totalMs = this.chartEndMoment.valueOf() - chartStart.valueOf();
		if (!width || !totalMs) return chartStart.clone();
		var ratio = xPos / width;
		if (ratio < 0) ratio = 0;
		if (ratio > 1) ratio = 1;
		return chartStart.clone().add(ratio * totalMs, "milliseconds");
	};
	bar.computed.barStyle = function() {
		var xStart = this.mapTimeToPosition(this.barStartMoment);
		var endMoment = this.barEndMoment.clone();
		if (endMoment.hour() === 0 && endMoment.minute() === 0 && endMoment.second() === 0 && endMoment.millisecond() === 0) {
			endMoment.add(1, "day");
		}
		var xEnd = this.mapTimeToPosition(endMoment);
		if (xEnd < xStart) xEnd = xStart;
		return Object.assign({}, this.barConfig || {}, {
			left: xStart + "px",
			width: (xEnd - xStart) + "px",
			height: (this.ganttChartProps.rowHeight - 15) + "px",
			zIndex: (this.barConfig && this.barConfig.zIndex) || (this.isDragging ? 2 : 1)
		});
	};
}
/** Calendar day as local midnight, so the Gantt uses the same date shown in the table. */
function fn_ganttDateTime(val) {
	var d = fn_parseDateOnly(val);
	if (!d) return val;
	var m = String(d.getMonth() + 1).padStart(2, "0");
	var day = String(d.getDate()).padStart(2, "0");
	return d.getFullYear() + "-" + m + "-" + day + " 00:00:00";
}
/** Parse YYYY-MM-DD (or Date) as a local calendar day — avoids UTC off-by-one. */
function fn_parseDateOnly(val) {
	if (!val) return null;
	if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}/.test(val)) {
		const [y, m, d] = val.slice(0, 10).split('-').map(Number);
		return new Date(y, m - 1, d);
	}
	const dt = new Date(val);
	if (isNaN(dt.getTime())) return null;
	return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
}
/** Inclusive Mon–Fri count between start and end; 0 if missing/invalid. */
function fn_countWeekdays(startDate, endDate) {
	const cur = fn_parseDateOnly(startDate);
	const last = fn_parseDateOnly(endDate);
	if (!cur || !last || last < cur) return 0;
	let count = 0;
	while (cur <= last) {
		const day = cur.getDay();
		if (day !== 0 && day !== 6) count++;
		cur.setDate(cur.getDate() + 1);
	}
	return count;
}
function fn_roundMoney(n) {
	if (n == null || isNaN(n)) return null;
	return Math.round((n + Number.EPSILON) * 100) / 100;
}
/** periodCost = rate × weekdays × 8 × (alloc% / 100); Rate is hourly. */
function fn_periodCostFromRate(rate, period) {
	if (rate == null || rate === '' || isNaN(parseFloat(rate))) return null;
	if (!period) return null;
	const pct = period.timePercent;
	if (pct == null || pct === '' || isNaN(parseFloat(pct))) return null;
	const weekdays = fn_countWeekdays(period.startDate, period.endDate);
	if (!weekdays) return null;
	const hours = weekdays * 8 * (parseFloat(pct) / 100);
	return fn_roundMoney(parseFloat(rate) * hours);
}
/** Prefer stored Create Staffing cost; else recompute from rate. */
function fn_resolvePeriodCost(period) {
	if (!period) return null;
	if (period.cost != null && period.cost !== '' && !isNaN(parseFloat(period.cost))) {
		return fn_roundMoney(parseFloat(period.cost));
	}
	return fn_periodCostFromRate(period.rate, period);
}
function fn_staffCostForPeriods(periods) {
	if (!periods || !periods.length) return null;
	let total = 0;
	let any = false;
	periods.forEach(p => {
		const c = fn_resolvePeriodCost(p);
		if (c != null && !isNaN(c)) {
			total += c;
			any = true;
		}
	});
	return any ? fn_roundMoney(total) : null;
}
/**
 * Weekday-prorate period cost into calendar months (clipped to chart range).
 * month share = C × (weekdays in month ∩ period) / W
 */
function fn_prorateCostByMonth(period, chartStart, chartEnd) {
	const C = fn_resolvePeriodCost(period);
	if (C == null || C === 0) return {};
	const W = fn_countWeekdays(period.startDate, period.endDate);
	if (!W) return {};
	const pStart = fn_parseDateOnly(period.startDate);
	const pEnd = fn_parseDateOnly(period.endDate);
	if (!pStart || !pEnd) return {};
	const cStart = fn_parseDateOnly(chartStart);
	const cEnd = fn_parseDateOnly(chartEnd);
	let rangeStart = pStart;
	let rangeEnd = pEnd;
	if (cStart && rangeStart < cStart) rangeStart = new Date(cStart.getFullYear(), cStart.getMonth(), cStart.getDate());
	if (cEnd && rangeEnd > cEnd) rangeEnd = new Date(cEnd.getFullYear(), cEnd.getMonth(), cEnd.getDate());
	if (rangeEnd < rangeStart) return {};
	const result = {};
	let y = rangeStart.getFullYear();
	let m = rangeStart.getMonth();
	const endY = rangeEnd.getFullYear();
	const endM = rangeEnd.getMonth();
	while (y < endY || (y === endY && m <= endM)) {
		const monthStart = new Date(y, m, 1);
		const monthEnd = new Date(y, m + 1, 0);
		// Intersect month with full period (not chart) for weekday share of C
		const overlapStart = monthStart > pStart ? monthStart : pStart;
		const overlapEnd = monthEnd < pEnd ? monthEnd : pEnd;
		if (overlapEnd >= overlapStart) {
			// Only emit months that also intersect the chart-visible range
			const visStart = monthStart > rangeStart ? monthStart : rangeStart;
			const visEnd = monthEnd < rangeEnd ? monthEnd : rangeEnd;
			if (visEnd >= visStart) {
				const weekdaysInMonth = fn_countWeekdays(overlapStart, overlapEnd);
				if (weekdaysInMonth > 0) {
					const key = y + '-' + String(m + 1).padStart(2, '0');
					result[key] = fn_roundMoney(C * weekdaysInMonth / W);
				}
			}
		}
		m++;
		if (m > 11) { m = 0; y++; }
	}
	return result;
}
function fn_mergeMonthlyCosts(periods, chartStart, chartEnd) {
	const merged = {};
	(periods || []).forEach(p => {
		const map = fn_prorateCostByMonth(p, chartStart, chartEnd);
		Object.keys(map).forEach(k => {
			merged[k] = fn_roundMoney((merged[k] || 0) + map[k]);
		});
	});
	return merged;
}
function fn_add_barRow(barData){

	var barRows=[];
	var bars=[]
	var backgroundColor;
	var color="white";

	
	barData.forEach((b,idx)=>{
		
		console.log('barData',b);
		if(b.recordType=='opportunity') backgroundColor=GANTT_COLORS.opportunity;
		else if(b.recordType=='project') backgroundColor=GANTT_COLORS.project; 
		else if(b.recordType=='available') backgroundColor=GANTT_COLORS.available;
		
		if(b.roleId==0){
			// Project Roles header bar — purple Precon, blue Construction Phase (default for other statuses)
			backgroundColor=fn_isPreconProjectStatus(b) ? GANTT_COLORS.precon : GANTT_COLORS.projectHeader;
			color="white";
		}
		
		if(b.recordType=='opportunity'&& b.timePercent) color="#ff8000";
		if(b.recordType=='project'&& b.timePercent && b.roleId!==0) color="yellow";
		if(b.recordType=='available') color="white";
		// Unassigned role — highlight so reviewers know a team member must be filled
		if(!b.teamMemberId && b.roleId){
			backgroundColor=GANTT_COLORS.unfilled;
			color="white";
		}
		// Precon period with an assigned team member → purple bar
		else if(b.precon && b.teamMemberId){
			backgroundColor=GANTT_COLORS.precon;
			color="white";
		}
        console.log('backgroundColor #9c27b0',backgroundColor);
		var bar={		startDate:fn_ganttDateTime(b.startDate),
						endDate:fn_ganttDateTime(b.endDate),
						recordType:b.recordType,
						recordId:b.recordId,
						recordName:b.recordName,
						recordNo:b.recordNo,
						teamMemberId:b.teamMemberId,
						teamMemberName:b.teamMemberName,
						roleId:b.roleId,
						roleName:b.roleName,
						project:b.recordType=='project'?b.recordName:null,
						opportunity:b.recordType=='opportunity'?b.recordName:null,
						position:b.position?b.position:null,
						staffingDataId:b.staffingDataId,
						timePercent:b.timePercent,
						precon:!!b.precon,
						ganttBarConfig: {
										label:b.label,
										link:b.link,
										timePercent:b.timePercent,
										precon:!!b.precon,
										height: "18px",
										color:color,
										background:backgroundColor,
										borderTopLeftRadius: "0px", 
										borderBottomLeftRadius: "0px",
										fontSize: "8px",
										handles: false,
										drag: false,
										},
						};
		bars.push(bar);
		});
		
		if(barData.length) {
		barRows.push({	recordType:barData[0].recordType,
						recordName:barData[0].recordName,
						recordId:barData[0].recordId,
						recordNo:barData[0].recordNo,
						teamMemberId:barData[0].teamMemberId,
						teamMemberName:barData[0].teamMemberName,
						roleId:barData[0].roleId,
						roleName:barData[0].roleName,
						project:barData[0].recordType=='project'?barData[0].recordName:null,
						opportunity:barData[0].recordType=='opportunity'?barData[0].recordName:null,
						startDate:barData[0].startDate,
						endDate:barData[0].endDate,
						position:barData[0].position?barData[0].position:null,
						staffingDataId:barData[0].staffingDataId,
						bars: bars
				});
		}
		
	return barRows;
	
	}
	
function fn_getWorkingDays(endDate, startDate) {
	var lastDay = moment(endDate);
    var firstDay = moment(startDate);
    let workingDays = 1 + (lastDay.diff(firstDay, 'days') * 5 -
      (firstDay.day() - lastDay.day()) * 2) / 7;

    if (lastDay.day() == 6) workingDays--;//SAT
    if (firstDay.day() == 0) workingDays--;//SUN

    return workingDays;
  }
  
  
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.year-wrapper {
  height: 30px;
  display: flex;
  align-items: center;
}
table th {
  border: none !important;
  //padding:0em;
}

table td {
  border: none !important;
  //padding:0em;
}
.team_avatar {
  width: 25px;
  height: 25px;
  background: rgb(149, 1, 1);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.small-table { max-width: 400px; }
.staffing-toolbar {
	gap: 0.5rem;
	align-items: center;
	width: 100%;
}
.staffing-toolbar-right {
	gap: 0.35rem;
}
.staffing-export-dropdown ::v-deep .dropdown-toggle {
	padding: 0.25rem 0.5rem;
	border: none;
}
.staffing-export-dropdown ::v-deep .dropdown-menu {
	min-width: 240px;
	padding: 0;
	border: none;
	background: transparent;
	box-shadow: none;
}
.staffing-export .topright-close {
	position: absolute;
	top: 2px;
	right: 8px;
	font-size: 20px;
	cursor: pointer;
	z-index: 2;
}
.staffing-export .topright-close:hover {
	color: red;
}
.btn-menu {
	border: none;
}
@media (max-width: 576px) {
	.staffing-toolbar .staffing-toolbar-right {
		margin-left: 0 !important;
		width: 100%;
		justify-content: flex-end;
	}
	.staffing-toolbar .staffing-filter {
		margin-left: 0 !important;
	}
	#mainContainer {
		overflow-x: auto;
		max-width: 100%;
	}
}
.small-round-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.staffing-photo-bubble {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	min-width: 22px;
	border-radius: 50%;
	overflow: hidden;
	margin-right: 4px;
	vertical-align: middle;
	cursor: pointer;
	background: #e9ecef;
	border: 1px solid #ced4da;
	flex-shrink: 0;
}
.staffing-photo-bubble img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}
.staffing-photo-initials {
	font-size: 9px;
	font-weight: 700;
	line-height: 1;
	color: #495057;
	user-select: none;
}
.staffing-photo-bubble--unfilled {
	cursor: default;
	background: #dee2e6;
}
.staffing-photo-silhouette {
	font-size: 11px;
	color: #6c757d;
}
.staffing-name-cell {
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	gap: 4px;
	white-space: normal;
	line-height: 1.25;
	min-width: 0;
}
.staffing-name-cell > a,
.staffing-name-cell > .staffing-unfilled-name {
	flex: 1 1 auto;
	min-width: 0;
	white-space: normal;
	word-break: break-word;
	overflow-wrap: anywhere;
}
.table thead th, thead, th {
    border-bottom: solid;
}
.rowStyle {
	font-weight: normal;
	height: 48px !important;
	box-sizing: border-box;
}
/* Shared vertical scroll — headers stay sticky; only data rows move */
.staffing-main {
	width: 100%;
}
.staffing-body-scroll {
	overflow-y: auto;
	overflow-x: hidden;
	max-height: calc(100vh - 200px);
	width: 100%;
}
/* Side-by-side table + Gantt layout — flush, no gap */
.staffing-split-row {
	display: flex !important;
	flex-wrap: nowrap !important;
	width: 100%;
	gap: 0 !important;
	margin: 0 !important;
	align-items: flex-start;
}
/* Table pane butts directly against the Gantt */
.table-column {
	flex: 0 0 460px !important;
	flex-shrink: 0 !important;
	max-width: 460px !important;
	min-width: 460px !important;
	width: 460px !important;
	padding: 0 !important;
	margin: 0 !important;
	overflow: visible;
	background: #fff;
	border-right: 1px solid #ccc;
}
.staffing-table {
	table-layout: fixed;
	width: 100% !important;
	margin: 0 !important;
	border-collapse: separate;
	border-spacing: 0;
}
.staffing-table ::v-deep .staffing-cell,
.staffing-table ::v-deep th {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
/* Sticky column header under the year spacer */
.staffing-table ::v-deep thead th {
	position: sticky !important;
	top: 28px;
	z-index: 3;
	background: #fff !important;
	box-shadow: inset 0 -1px 0 #adb5bd;
}
/* Name / Title wrap instead of truncating */
.staffing-table ::v-deep .staffing-cell-wrap {
	white-space: normal !important;
	text-overflow: clip;
	overflow: hidden;
	vertical-align: middle;
	word-break: break-word;
	line-height: 1.25;
}
.staffing-wrap-text {
	white-space: normal;
	word-break: break-word;
	line-height: 1.25;
}
.staffing-title {
	font-weight: 600;
}
.staffing-unfilled-name {
	color: #dc3545;
	font-weight: 600;
}
/* Gantt fills remaining space, flush against the table */
.chart-column {
	flex: 1 1 0px !important;
	min-width: 0 !important;
	max-width: none !important;
	width: auto !important;
	padding: 0 !important;
	margin: 0 !important;
	overflow: visible;
}
.chart-container {
	width: 100%;
	min-width: 0 !important;
	margin-right: 0;
	overflow: visible;
}
.table-year-header,
.chart-year-header {
	height: 28px;
	width: 100%;
	box-sizing: border-box;
	border-bottom: 1px solid #dee2e6;
	position: sticky;
	top: 0;
	z-index: 4;
	background: #fff;
}
.table-year-header {
	border-bottom: 1px solid #dee2e6;
}
.chart-year-label {
	min-width: 0;
	text-align: center;
	font-size: 12px;
	font-weight: bold;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	padding: 0 2px;
	border-right: 2px solid #6c757d;
}
.chart-year-label:last-child {
	border-right: none;
}
.chart-month-header {
	display: flex;
	height: 40px;
	width: 100%;
	box-sizing: border-box;
	position: sticky;
	top: 28px;
	z-index: 3;
	background: #fff;
	box-shadow: inset 0 -1px 0 #adb5bd;
}
.chart-month-label {
	flex: 1 1 0px;
	min-width: 0;
	text-align: center;
	font-size: 11px;
	font-weight: bold;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	padding: 0 2px;
}
.chart-month-label--divided {
	border-right: 1px solid #adb5bd;
	box-sizing: border-box;
}
.chart-month-label--divided:last-child {
	border-right: none;
}
.chart-gantt-wrap {
	position: relative;
	width: 100%;
}
.chart-month-grid {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	pointer-events: none;
	z-index: 1;
}
.chart-month-grid-col {
	flex: 1 1 0px;
	min-width: 0;
	border-right: 1px solid rgba(173, 181, 189, 0.85);
	box-sizing: border-box;
}
.chart-month-grid-col:last-child {
	border-right: none;
}
.chart-month-cost-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	z-index: 2;
	pointer-events: none;
}
.chart-month-cost-row {
	display: flex;
	width: 100%;
	box-sizing: border-box;
	height: var(--staffing-row-h, 48px) !important;
}
.chart-month-cost-cell {
	flex: 1 1 0px;
	min-width: 0;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	padding: 0 1px 2px;
	font-size: 9px;
	font-weight: 700;
	line-height: 1;
	color: #212529;
	text-shadow: 0 0 2px rgba(255, 255, 255, 0.9);
	overflow: hidden;
	white-space: nowrap;
	border-right: 1px solid transparent;
	box-sizing: border-box;
}
.chart-month-cost-row--total {
	background: rgba(248, 249, 250, 0.92);
}
.chart-month-cost-row--total .chart-month-cost-cell {
	font-weight: 800;
	align-items: center;
}
.chart-month-cost-row--grand {
	background: rgba(233, 236, 239, 0.95);
	border-top: 1px solid #adb5bd;
}
.staffing-gc-total-label {
	font-weight: 800;
	color: #212529;
}
.staffing-gc-total-cost {
	font-weight: 800;
}
.staffing-table ::v-deep tr.staffing-gc-total-row > td {
	background: #f8f9fa !important;
	font-weight: 800;
	border-top: 1px solid #ced4da;
}
.staffing-table ::v-deep tr.staffing-gc-grand-total-row > td {
	background: #e9ecef !important;
	border-top: 2px solid #6c757d;
}
/* Deep selectors: bars/rows render inside vue-ganttastic child components.
   Height follows the staffing table row (--staffing-row-h) so wrapped project names stay aligned. */
::v-deep .g-gantt-row {
	height: var(--staffing-row-h, 48px) !important;
	box-sizing: border-box;
}
/* Default row label ("Row") must not steal width from the bars */
::v-deep .g-gantt-row-label {
	display: none !important;
	width: 0 !important;
	min-width: 0 !important;
	padding: 0 !important;
	overflow: hidden !important;
}
::v-deep .g-gantt-bar {
    height: 18px !important;
    top: 50% !important;
    margin-top: -9px !important; /* half of bar height — centers on person row */
    border-top-right-radius: 9px !important;
    border-bottom-right-radius: 9px !important;
}
::v-deep .g-gantt-bar-label {
    padding: 0 4px !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	overflow: hidden !important;
}
.gantt-bar-label {
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	overflow: hidden;
	min-width: 0;
}
.gantt-bar-label--alloc {
	justify-content: center;
}
.gantt-bar-alloc {
	font-size: 12px;
	font-weight: 800;
	line-height: 1;
	letter-spacing: -0.02em;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: clip;
	text-shadow: 0 0 2px rgba(0, 0, 0, 0.35);
	pointer-events: none;
}
.gantt-bar-text {
	font-size: 8px;
	font-weight: 600;
	line-height: 1;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100%;
}
.gantt-bar-text--bold {
	font-weight: 800;
}
::v-deep #g-gantt-chart {
	width: 100% !important;
	padding-bottom: 0 !important;
	overflow-x: hidden !important;
}
::v-deep .g-gantt-row > .g-gantt-row-bars-container {
	width: 100% !important;
	flex: 1 1 auto !important;
	min-width: 0 !important;
}
.chartRange{
	width: 100px;
	margin-left: 20px!important;
	}
th:last-child {
    border-right: 0px !important;
}
/* Match table header/row heights to Gantt rows so grey lines align */
.project-staffing ::v-deep .table thead th {
	height: 40px;
	padding-top: 0;
	padding-bottom: 0;
	padding-left: 0.35rem;
	padding-right: 0.35rem;
	vertical-align: middle;
	box-sizing: border-box;
	position: sticky;
	top: 28px;
	z-index: 3;
	background: #fff !important;
}
.project-staffing ::v-deep .table tbody tr.rowStyle > td {
	height: 48px;
	max-height: 48px;
	padding-top: 0;
	padding-bottom: 0;
	padding-left: 0.35rem;
	padding-right: 0.35rem;
	vertical-align: middle;
	box-sizing: border-box;
}
.resizable {
    position: relative;
    //border-right: 1px solid #ccc;
    //padding: 10px;
}
.resizer2 {
    position: absolute;
    top: 0;
    right: -5px;
    width: 5px;
	border-right:0px;
    height: 100%;
    cursor: col-resize;
    //background: rgba(0, 0, 0, 0.2);
}
.sortableColumn:hover {
						cursor: pointer;
						text-decoration: underline;
}
.staffing-color-keys {
	margin-top: 0.75rem;
	padding-top: 0.35rem;
	border-top: 1px solid #dee2e6;
}
.staffing-color-key {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	padding: 0.35rem 0.25rem;
	font-size: 12px;
	line-height: 1.2;
	color: #495057;
}
.staffing-color-key-title {
	font-weight: 700;
	margin-right: 1rem;
	color: #343a40;
}
.staffing-color-key-item {
	display: inline-flex;
	align-items: center;
	margin-right: 1.5rem;
	white-space: nowrap;
}
.staffing-color-swatch {
	display: inline-block;
	width: 12px;
	height: 12px;
	min-width: 12px;
	min-height: 12px;
	margin-right: 6px;
	border-radius: 2px;
	flex: 0 0 12px;
	line-height: 12px;
	font-size: 0;
	vertical-align: middle;
	box-sizing: border-box;
	border: 1px solid rgba(0, 0, 0, 0.12);
}
.staffing-color-swatch--precon {
	background-color: #9c27b0 !important;
}
.staffing-color-swatch--construction {
	background-color: #4076ba !important;
}
.staffing-color-swatch--project-construction {
	background-color: #3399ff !important;
}
.staffing-color-swatch--unfilled {
	background-color: #dc3545 !important;
}
.staffing-color-swatch--potential {
	background-color: #9dc254 !important;
}
.staffing-color-label {
	font-weight: 600;
}
.staffing-color-label--precon {
	color: #9c27b0;
}
.staffing-color-label--construction {
	color: #4076ba;
}
.staffing-color-label--project-construction {
	color: #3399ff;
}
.staffing-color-label--unfilled {
	color: #dc3545;
}
.staffing-color-label--potential {
	color: #9dc254;
}
</style>
